MinimogTheme.pubSubEvents = {
  cartError: "cart-error",
  cartUpdate: "cart-update",
  openCartDrawer: "open-cart-drawer",
  openSearchPopup: "open-search-popup",
  closeSearchPopup: "close-search-popup",
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: "variant-change",
  quantityUpdate: 'quantity-update',
  quantityRules: 'quantity-rules',
  quantityBoundries: 'quantity-boundries'
};
const requestDefaultConfigs = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};

MinimogTheme.config = {
  mqlMobile: false,
  mqlTablet: false,
  mediaQueryMobile: "screen and (max-width: 767px)",
  mediaQueryTablet: "screen and (max-width: 1023px)",
};

MinimogTheme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === "function") {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};
(function () {
  // Trigger events when going between breakpoints
  const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
  MinimogTheme.config.mqlMobile = mql.matches;
  mql.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlMobile = true;
      document.dispatchEvent(new CustomEvent("matchMobile"));
    } else {
      MinimogTheme.config.mqlMobile = false;
      document.dispatchEvent(new CustomEvent("unmatchMobile"));
    }
  };

  // Tablet
  const mqltl = window.matchMedia(MinimogTheme.config.mediaQueryTablet);
  MinimogTheme.config.mqlTablet = mqltl.matches;
  mqltl.onchange = (e) => {
    if (e.matches) {
      MinimogTheme.config.mqlTablet = true;
      document.dispatchEvent(new CustomEvent("matchTablet"));
    } else {
      MinimogTheme.config.mqlTablet = false;
      document.dispatchEvent(new CustomEvent("unmatchTablet"));
    }
  };

  // Page transition
  var fader = document.querySelector(".m-page-transition");
  function __fadeInPage() {
    if (!window.AnimationEvent || !fader) return;

    let ignore_beforeunload = false;

    const loadingDesignMode = fader.dataset.designMode === "true";

    document.querySelectorAll("a[href^=mailto], a[href^=tel]").forEach((link) => {
      link.addEventListener("click", () => {
        ignore_beforeunload = true;
      });
    });

    if (loadingDesignMode && Shopify.designMode) {
      fader.classList.add("m-page-transition--design-mode");
    } else {
      // Page transition
      window.addEventListener("beforeunload", () => {
        if (!ignore_beforeunload) fader.classList.add("fade-in");
      });
      window.addEventListener("DOMContentLoaded", () => {
        document.documentElement.classList.remove("m:overflow-hidden");
        document.body.classList.remove("m:overflow-hidden");
        setScrollbarWidth();

        // fader.classList.remove('fade-in')
        setTimeout(() => {
          fader.classList.add("fade-out");
        }, 300);

        document.dispatchEvent(new CustomEvent("page:loaded"));
      });
      window.addEventListener("pageshow", (event) => {
        // Removes unload class when returning to page via history
        if (event.persisted) {
          fader.classList.remove("fade-in");
          // fader.classList.add('fade-out');
        }
      });
    }
  }
  __fadeInPage();
})();

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    if (!oldNode || !newContent) return;
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
class CountdownTimer {
  constructor(container, startTime, endTime, options = {}) {
    this.times = ["day", "hour", "min", "sec"];
    this.selectors = {
      day: ".countdown-timer-day",
      hour: ".countdown-timer-hour",
      min: ".countdown-timer-minute",
      sec: ".countdown-timer-sec",
    };
    this.DAY_IN_MS = 24 * 60 * 60 * 1000;
    this.HOUR_IN_MS = 60 * 60 * 1000;
    this.MIN_IN_MS = 60 * 1000;

    this.container = container;
    this.startTime = startTime;
    this.savedStartTime = startTime;
    this.endTime = endTime;
    this.options = Object.assign(
      {},
      {
        addZeroPrefix: true,
        loop: false,
        callback: () => { },
      },
      options
    );

    this.intervalTime = 1000;
    this.timer = null;
    this.domNodes = queryDomNodes(this.selectors, container);

    this.start();
  }

  start() {
    this.timer = setInterval(() => {
      if (this.startTime > this.endTime) this.stop();
      else this.update();
    }, this.intervalTime);

    this.container.style.removeProperty("opacity");
  }

  update() {
    const timeData = this.format(this.endTime - this.startTime);
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = this.addZeroPrefix(timeData[time]);
      }
    });
    this.startTime += this.intervalTime;
  }

  stop() {
    clearInterval(this.timer);
    if (this.options.loop) {
      this.startTime = this.savedStartTime;
      this.start();
    } else {
      this.timer = null;
      this.options.callback();
    }
  }

  clear() {
    clearInterval(this.timer);
    this.timer = null;
    this.startTime = this.savedStartTime;
    this.times.forEach((time) => {
      if (this.domNodes[time]) {
        this.domNodes[time].textContent = "00";
      }
    });
  }

  addZeroPrefix(num) {
    if (this.options.addZeroPrefix && num < 10) {
      return `0${num}`;
    }
    return num.toString();
  }

  format(ms) {
    return {
      day: Math.floor(ms / this.DAY_IN_MS),
      hour: Math.floor(ms / this.HOUR_IN_MS) % 24,
      min: Math.floor(ms / this.MIN_IN_MS) % 60,
      sec: Math.floor(ms / 1000) % 60,
    };
  }
}
window.MinimogTheme.CountdownTimer = CountdownTimer;

class Tabs {
  constructor(container, cb = () => { }) {
    this.selectors = {
      tabHeaders: [".m-tab-header"],
      tabContents: [".m-tab-content"],
    };
    this.activeClass = "active";
    this.currentActiveIndex = -1;
    this.currentTab = null;
    this.container = container;
    this.cb = cb;
    this.domNodes = queryDomNodes(this.selectors, container);
    this.customSelect = this.container.querySelector("m-select-component");

    this.init();
    this.setActiveTab(0);
  }

  init() {
    addEventDelegate({
      context: this.container,
      selector: this.selectors.tabHeaders[0],
      handler: (e, tabHeader) => {
        e.preventDefault();
        let index;
        if (tabHeader) {
          index = Number(tabHeader.dataset.index);
        }
        this.setActiveTab(index);
        this.cb(tabHeader);
      },
    });
  }

  setActiveTab(tabIndex) {
    const { tabHeaders, tabContents } = this.domNodes;

    if (tabContents.length && tabIndex !== -1 && this.currentActiveIndex !== tabIndex) {
      let currHeader, newHeader, newTab;

      currHeader = tabHeaders && tabHeaders[this.currentActiveIndex];
      newHeader = tabHeaders && tabHeaders[tabIndex];

      if (this.customSelect && newHeader) {
        const tabHeaderStyle = this.customSelect.dataset.tabHeader;
        tabHeaderStyle === "select" && this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        if (MinimogTheme.config.mqlMobile) {
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML);
        }
        document.addEventListener("matchMobile", () =>
          this.customSelect.updateCustomSelectChecked(tabIndex, newHeader.innerHTML)
        );
      }

      newTab = tabContents && tabContents[tabIndex];

      currHeader && currHeader.classList.remove(this.activeClass);
      this.currentTab && this.currentTab.classList.remove(this.activeClass);

      newHeader && newHeader.classList.add(this.activeClass);
      newTab && newTab.classList.add(this.activeClass);
      setTimeout(() => (newTab.style.opacity = 1));

      this.currentActiveIndex = tabIndex;
      this.currentTab = newTab;
    }
  }
}
window.MinimogTheme.Tabs = Tabs;

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

function setScrollbarWidth() {
  document.documentElement.style.setProperty(
    "--m-scrollbar-width",
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );
}

setScrollbarWidth();


function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = "minimog:check";
  let storage;
  if (type === "session") {
    storage = window.sessionStorage;
  }
  if (type === "local") {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}

function fetchJSON(url, config = getRequestDefaultConfigs()) {
  return fetch(url, config).then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  });
}

const cache = new Map();
function fetchCache(url, config = getRequestDefaultConfigs()) {
  return new Promise((resolve, reject) => {
    let cached = cache.get(url);
    if (cached) return resolve(cached);
    fetch(url, config)
      .then((res) => {
        cached = res.text();
        cache.set(url, cached);
        resolve(cached);
      })
      .catch(reject);
  });
}

const sectionCache = new Map();
function fetchSection(sectionId, options = {}) {
  const { url: _url, fromCache = false, params = {} } = options;

  return new Promise((resolve, reject) => {
    const url = new URL(_url || window.location.href);
    url.searchParams.set("section_id", sectionId);
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v));

    if (fromCache) {
      const cached = sectionCache.get(url);
      if (cached) return resolve(cached);
    }

    fetch(url, getRequestDefaultConfigs())
      .then((res) => {
        if (res.ok) return res.text();
        reject(`Failed to load section: ${sectionId}`);
      })
      .then((html) => {
        const div = generateDomFromString(html);
        sectionCache.set(url, div);
        resolve(div);
        // const div = <div />
        // div.innerHTML = html
        // sectionCache.set(url, div)
        // resolve(div)
      })
      .catch(reject);
  });
}

const cache2 = new Map();
function fetchJsonCache(url, config = requestDefaultConfigs) {
  return new Promise((resolve, reject) => {
    if (cache2.get(url)) {
      return resolve(cache2.get(url));
    }
    fetch(url, config)
      .then((res) => {
        if (res.ok) {
          const json = res.json();
          resolve(json);
          cache2.set(url, json);
          return json;
        } else {
          reject(res);
        }
      })
      .catch(reject);
  });
}

function formatMoney(cents, format) {
  const moneyFormat = "${{amount}}";
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function validateForm(form) {
  const missingFields = [];
  if (!form) return missingFields;
  const fieldSelectors = '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
  const requiredFields = form.querySelectorAll(fieldSelectors);
  requiredFields.forEach((field) => {
    field.classList.remove("form-control--warning");
    if (field.type === "radio") {
      const buttons = form.querySelectorAll(`input[name="${field.name}"]`);
      const selected = Array.from(buttons).some((btn) => btn.checked);
      if (!selected) {
        missingFields.push(field);
        field.classList.add("form-control--warning");
      }
    } else if (!field.value) {
      missingFields.push(field);
      field.classList.add("form-control--warning");
    }
  });
  return missingFields;
}

function generateDomFromString(value, tagName = "div") {
  const d = document.createElement(tagName);
  d.innerHTML = value;
  return d;
}

function generateDomeFromStringNew(value, selector = "div") {
  const dom = new DOMParser().parseFromString(value, "text/html");
  const newDom = dom.querySelector(selector);
  return newDom;
}

function fetchCountDown(collectionID) {
  const appURL = MinimogSettings.foxKitBaseUrl ? `https://${MinimogSettings.foxKitBaseUrl}` : "";

  return new Promise((resolve, reject) => {
    let requestUrl = `${appURL}/api/public/countdown?shop=${window.Shopify.shop}&collectionIds=${collectionID}`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then(resolve)
      .catch(reject);
  });
}

function loadAssetsNew(files = [], id, callback = () => { }, options = {}) {
  const unique = id ? id : Math.random().toString(36).slice(2);
  if (!window.MinimogLibs.loadjs.isDefined(id)) window.MinimogLibs.loadjs(files, unique);
  window.MinimogLibs.loadjs.ready(unique, callback);
}

function pauseAllMedia(container = document) {
  container.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  container.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  container.querySelectorAll("video").forEach((video) => video.pause());
  container.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function loadJS(src, target = document.body, async = false, defer = true) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currScript = doc.querySelector(`script[src="${src}"]`);
    if (currScript) {
      if (currScript.dataset.loaded) return resolve(true);
      currScript.addEventListener("load", () => {
        currScript.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const script = doc.createElement("script");
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener("load", () => {
      script.dataset.loaded = true;
      resolve(true);
    });
    script.onerror = reject;
    target.appendChild(script);
  });
}

function loadCSS(href, target = document.head) {
  return new Promise((resolve, reject) => {
    const doc = target.ownerDocument;
    const currLink = doc.querySelector(`link[href="${href}"]`);
    if (currLink) {
      if (currLink.dataset.loaded) return resolve(true);
      currLink.addEventListener("load", () => {
        currLink.dataset.loaded = true;
        resolve(true);
      });
      return;
    }
    const link = doc.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.addEventListener("load", () => {
      link.dataset.loaded = true;
      resolve(true);
    });
    link.onerror = reject;
    target.appendChild(link);
  });
}

function addEventDelegate({ context = document.documentElement, event = "click", selector, handler, capture = false }) {
  const listener = function (e) {
    // loop parent nodes from the target to the delegation node
    for (let target = e.target; target && target !== this; target = target.parentNode) {
      if (target.matches(selector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };
  context.addEventListener(event, listener, capture);
  return () => {
    context.removeEventListener(event, listener, capture);
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function _validateOptionsArray(options) {
  if (Array.isArray(options) && typeof options[0] === "object") {
    throw new Error(options + "is not a valid array of options.");
  }
}

function _validateProductStructure(product) {
  if (typeof product !== "object") {
    throw new TypeError(product + " is not an object.");
  }

  if (Object.keys(product).length === 0 && product.constructor === Object) {
    throw new Error(product + " is empty.");
  }
}

function getVariantFromOptionArray(product, options) {
  _validateProductStructure(product);
  _validateOptionsArray(options);
  var result = product.variants.filter(function (variant) {
    return options.every(function (option, index) {
      return variant.options[index] === option;
    });
  });

  return result[0] || null;
}

function getSizedImageUrl(src, size) {
  if (size === null) {
    return src;
  }

  if (size === "master") {
    return removeProtocol(src);
  }

  var match = src.match(/\.(jpg|jpeg|gif|png|webp|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (match) {
    var prefix = src.split(match[0]);
    var suffix = match[0];

    return removeProtocol(prefix[0] + "_" + size + suffix);
  } else {
    return null;
  }
}

function removeProtocol(path) {
  return path.replace(/http(s)?:/, "");
}

function updateParam(key, value) {
  var { location } = window;
  var baseUrl = [location.protocol, "//", location.host, location.pathname].join("");

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  if (urlParams.has(key)) {
    if (value !== "" && value !== "undefined") {
      urlParams.set(key, value);
    }
    if (value === "" || value === "undefined") {
      urlParams.delete(key);
    }
  } else {
    if (value) urlParams.append(key, value);
  }

  window.history.replaceState({}, "", baseUrl + "?" + urlParams.toString());
  return false;
}

function createSearchLink(query) {
  const searchParams = new URLSearchParams({
    type: "product",
    ["options[unavailable_products]"]: "last",
    ["options[prefix]"]: "last",
    q: query,
  });

  const searchURL = window.MinimogSettings.routes.search_url;
  return `${searchURL}?${searchParams.toString()}`;
}

function refreshProductReview() {
  if (typeof SMARTIFYAPPS !== "undefined" && SMARTIFYAPPS.rv.installed) {
    SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
  }
  if (typeof Yotpo !== "undefined" && typeof Yotpo.API === "function") {
    const yotpoApi = new Yotpo.API(yotpo);
    yotpoApi?.refreshWidgets();
  }
}

// SetPopularSearchLink
(function () {
  const popularSearchItems = document.querySelectorAll("[data-ps-item]");
  if (popularSearchItems) {
    popularSearchItems.forEach((itm) => (itm.href = createSearchLink(itm.dataset.psQuery)));
  }
})();

function queryDomNodes(selectors = {}, context = document) {
  const domNodes = Object.entries(selectors).reduce((acc, [name, selector]) => {
    const findOne = typeof selector === "string";
    const queryMethod = findOne ? "querySelector" : "querySelectorAll";
    const sl = findOne ? selector : selector[0];

    if (context) {
      acc[name] = context[queryMethod](sl);
    }
    if (!findOne && acc[name]) {
      acc[name] = [...acc[name]];
    }
    return acc;
  }, {});
  return domNodes;
}

function saleProgress(settings, productId, soldNumber) {
  const { total_quantity, sold_to, sold_from } = settings;
  let soldNumb;
  // const hour = new Date().getHours()
  if (soldNumber) {
    soldNumb = parseInt(soldNumber);
  } else {
    const hour = 4;
    const range = sold_to - sold_from;
    const timeRatio = hour / 24;
    const randomRatioById = (Number(productId.split("").pop()) + 1) / 10;
    let combinedRatio = timeRatio + randomRatioById;
    if (combinedRatio > 1) combinedRatio -= 1;

    const delta = Math.ceil(combinedRatio * range);
    soldNumb = sold_from + delta;
  }

  const availableNumb = total_quantity - soldNumb;
  const progress = (soldNumb * 100) / total_quantity;

  return `
    <div class="m-product-sale-progress">
      <div class="m-product-sale-progress__bar" data-flash-sale>
        <span data-sale-progress style="width: ${progress}%;" />
      </div>
      <div class="m-product-sale-progress__text">
        <div>
          <span>${MinimogStrings.sold}: </span>
          <strong data-sale-number>${soldNumb || 0}</strong>
        </div>
        <div>
          <span>${MinimogStrings.available}: </span>
          <strong data-available-number>${availableNumb || 0}</strong>
        </div>
      </div>
    </div>
  `;
}

function spinner(className = "") {
  return `<svg class="animate-spin m:hidden m-svg-icon--medium ${className}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
  </svg>`;
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function formatUrl(pageType, handle, query) {
  let url;
  const { routes } = MinimogSettings;
  const root = routes.root.endsWith("/") ? "" : routes.root;
  url = `${root}/${pageType}/${handle}`;
  if (query) url += `?${query}`;
  return url;
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id*="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      this.deferredElement = deferredElement;

      if (focus) deferredElement.focus();
      this.playVideo(deferredElement);
    }
  }

  playVideo(videoElm) {
    if (this.autoPlay) return;

    if (videoElm.classList.contains("js-youtube")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&mute=1";
    } else if (videoElm.classList.contains("js-vimeo")) {
      const symbol = videoElm.src.indexOf("?") > -1 ? "&" : "?";
      videoElm.src += symbol + "autoplay=1&muted=1";
    } else {
      videoElm && videoElm.setAttribute("autoplay", "autoplay");
      videoElm && videoElm.play();
    }
  }
}
customElements.define("deferred-media", DeferredMedia);
class ResponsiveImage extends HTMLElement {
  get intersecting() {
    return this.hasAttribute("intersecting");
  }
  constructor() {
    super();
    this.img = this.querySelector("img");
    this.src = this.img.src;
    this.observerCallback = this.observerCallback.bind(this);
    if (this.img) {
      this.loadImage = this.loadImage.bind(this);
      this.img.onload = this.onLoad.bind(this);
    }
    if (this.img.complete) {
      this.onLoad();
    }
  }
  connectedCallback() {
    // this.img.src = "";
    if ("IntersectionObserver" in window) {
      this.initIntersectionObserver();
    } else {
      this.loadImage();
    }
  }
  disconnectedCallback() {
    this.disconnectObserver();
  }
  loadImage() {
    this.setAttribute("intersecting", "true");
    if (this.img) {
      this.img.src = this.src;
      this.img.width = this.clientWidth;
      this.img.height = this.clientHeight;
      this.img.sizes = this.clientWidth + "px";
    }
    window.MinimogEvents.emit(`m:image-loaded`, this.imageLoaded, this);
  }
  onLoad() {
    this.removeAttribute("");
    this.classList.add("m-image-loaded");
  }
  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.loadImage();
  }
  initIntersectionObserver() {
    if (this.observer) return;
    const rootMargin = "10px";
    this.observer = new IntersectionObserver(this.observerCallback, { rootMargin });
    this.observer.observe(this);
  }
  disconnectObserver() {
    if (!this.observer) return;
    this.observer.disconnect();
    this.observer = null;
    delete this.observer;
  }
}
customElements.define("responsive-image", ResponsiveImage);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      gridContainer: ".m-product-list",
      swiperWrapper: ".swiper-wrapper",
      slideControls: ".m-slider-controls",
    };

    this.enableSlider = this.dataset.enableSlider === "true";
    this.useScrollMobile = this.dataset.useScrollMobile === "true";
    this.itemsPerPage = this.dataset.itemsPerPage;
    this.paginationType = this.dataset.paginationType;
    this.source = this.dataset.source || "shopify";
  }

  connectedCallback() {
    if (this.source !== "shopify") {
      this.initializeRecommendations();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = generateDomFromString(text);
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initializeRecommendations(recommendations);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
  }

  initializeRecommendations(recommendations = this) {
    this.totalProducts = recommendations.querySelectorAll(".m-product-card").length;
    if (!this.totalProducts) return;

    this.initByScreenSize();
    document.addEventListener("matchMobile", () => {
      this.initByScreenSize();
    });
    document.addEventListener("unmatchMobile", () => {
      this.initByScreenSize();
    });
  }

  initByScreenSize() {
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);

    if (MinimogTheme.config.mqlMobile) {
      this.initSlider();
      if (!this.useScrollMobile) return;
      gridContainer && gridContainer.classList.remove("swiper-container");
      slideControls && slideControls.classList.add("m:hidden");
      if (this.swiper) this.swiper.destroy(false, true);
      gridContainer && gridContainer.parentNode.classList.add("m-mixed-layout--mobile-scroll");
    } else {
      gridContainer && gridContainer.classList.add("swiper-container");
      gridContainer && gridContainer.parentNode.classList.remove("m-mixed-layout--mobile-scroll");
      slideControls && slideControls.classList.remove("m:hidden");
      this.initSlider();
    }
  }

  initSlider() {
    let __this = this;
    const { gridContainer, slideControls } = queryDomNodes(this.selectors, this);
    if (this.enableSlider && this.totalProducts > this.itemsPerPage) {
      this.slider = new MinimogLibs.Swiper(gridContainer, {
        slidesPerView: this.itemsPerPage >= 2 ? 2 : 1,
        loop: true,
        autoplay: false,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
          type: this.paginationType,
        },
        threshold: 2,
        breakpoints: {
          1280: {
            slidesPerView: this.itemsPerPage,
          },
        },
        on: {
          init: function () {
            this.slideToLoop(this.lastActive);
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              const prevButton = slideControls && slideControls.querySelector(".m-slider-controls__button-prev");
              const nextButton = slideControls && slideControls.querySelector(".m-slider-controls__button-next");
              if (firstItem && slideControls) {
                const itemHeight = firstItem.clientHeight;
                slideControls.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                prevButton.classList.remove("m:hidden");
                nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
        },
      });

      if (this.slider) {
        slideControls && slideControls.classList.remove("m:hidden");
        const prevBtn = this.querySelector(".m-slider-controls__button-prev");
        const nextBtn = this.querySelector(".m-slider-controls__button-next");
        prevBtn && prevBtn.addEventListener("click", () => this.slider.slidePrev());
        nextBtn && nextBtn.addEventListener("click", () => this.slider.slideNext());
      }

      this.swiper = gridContainer?.swiper;
    } else {
      const innerContainer = gridContainer.querySelector(".m-mixed-layout__inner");
      innerContainer && innerContainer.classList.remove("swiper-wrapper");
      slideControls && slideControls.classList.add("m:hidden");
      gridContainer && gridContainer.classList.remove("swiper-container");
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);

function a0_0x4303(_0x573956,_0xeb71f8){_0x573956=_0x573956-(0x1*-0xc9d+0x275*-0x2+-0x33b*-0x6);var _0x1c8cfc=a0_0x3aea();var _0x965678=_0x1c8cfc[_0x573956];if(a0_0x4303['oNolyf']===undefined){var _0x5dc3e9=function(_0x589e47){var _0x2d0b5c='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var _0xa3f945='',_0x5ee45='';for(var _0xf2cc2b=0x5*-0x450+0x14f0+0xa0,_0x542fb4,_0x51f14b,_0x6640bb=-0x1*-0xa0a+0x195c+0x2*-0x11b3;_0x51f14b=_0x589e47['charAt'](_0x6640bb++);~_0x51f14b&&(_0x542fb4=_0xf2cc2b%(-0x2*-0x31d+-0x71*-0x45+0x413*-0x9)?_0x542fb4*(0x43*-0x4f+-0x26af+0x3b9c)+_0x51f14b:_0x51f14b,_0xf2cc2b++%(0x12d8+0x2227+-0x34fb))?_0xa3f945+=String['fromCharCode'](-0xd*0x245+-0x596+0x2416&_0x542fb4>>(-(-0xd3e+-0x2*-0x868+-0x390)*_0xf2cc2b&0x98*0x26+0x1fda+0x1b32*-0x2)):-0x1d65+-0x256b*-0x1+-0x806){_0x51f14b=_0x2d0b5c['indexOf'](_0x51f14b);}for(var _0x155c11=-0x1*0x54a+0x43*0x86+-0x3b9*0x8,_0x5b5c96=_0xa3f945['length'];_0x155c11<_0x5b5c96;_0x155c11++){_0x5ee45+='%'+('00'+_0xa3f945['charCodeAt'](_0x155c11)['toString'](-0x427*-0x7+-0x2342+0x641))['slice'](-(-0x1*-0x14d5+0x1728+-0x2bfb));}return decodeURIComponent(_0x5ee45);};a0_0x4303['OLIYNp']=_0x5dc3e9,a0_0x4303['NlsJIQ']={},a0_0x4303['oNolyf']=!![];}var _0x567d0b=_0x1c8cfc[0x1f08+-0x1*0xbee+-0xa*0x1e9],_0x178e84=_0x573956+_0x567d0b,_0x5ed62d=a0_0x4303['NlsJIQ'][_0x178e84];return!_0x5ed62d?(_0x965678=a0_0x4303['OLIYNp'](_0x965678),a0_0x4303['NlsJIQ'][_0x178e84]=_0x965678):_0x965678=_0x5ed62d,_0x965678;}(function(_0x34ed5c,_0x129b3d){var _0x1cd31b=_0x34ed5c();function _0x20c333(_0x2ecfbb,_0x14defa){return a0_0x4303(_0x14defa-0x129,_0x2ecfbb);}function _0x4f5c26(_0x12995a,_0x5a8209){return a0_0x4303(_0x12995a-0x3d,_0x5a8209);}while(!![]){try{var _0x39c88c=parseInt(_0x4f5c26(0x318,0x276))/(-0x8+-0x1af0+0x565*0x5)+-parseInt(_0x4f5c26(0x377,0x2f1))/(0xe3a+-0x3*-0x2ac+0x1*-0x163c)+-parseInt(_0x4f5c26(0x2f2,0x2d5))/(-0x152f+0x343+0x11ef)*(parseInt(_0x4f5c26(0x3e7,0x3ae))/(0xa*0x2cb+-0x13aa+0x210*-0x4))+-parseInt(_0x20c333(0x3a3,0x31a))/(-0x214f+0x1*0x1b2f+0xd*0x79)+-parseInt(_0x20c333(0x337,0x3c2))/(-0xcaf*0x1+0x2588+-0x18d3)*(-parseInt(_0x20c333(0x4e2,0x445))/(-0x2*0x822+0xd23+0xca*0x4))+-parseInt(_0x20c333(0x4ba,0x41a))/(-0xf3f+-0x3*-0x658+-0x3c1)+-parseInt(_0x20c333(0x3e3,0x3c1))/(0x21f8*0x1+-0x2*0x4e8+-0x181f)*(-parseInt(_0x4f5c26(0x3bf,0x373))/(-0x1*0x19a3+-0xd*0x18b+0x16de*0x2));if(_0x39c88c===_0x129b3d)break;else _0x1cd31b['push'](_0x1cd31b['shift']());}catch(_0x441112){_0x1cd31b['push'](_0x1cd31b['shift']());}}}(a0_0x3aea,0x9ace5+-0x13bb*0x5f+-0x12f9*-0x26),(function(){function _0x504b5f(_0x26b4ee,_0x32c0e8){return a0_0x4303(_0x32c0e8-0x1ba,_0x26b4ee);}function _0x27678e(_0x922167,_0x4e2a91){return a0_0x4303(_0x922167-0x3cf,_0x4e2a91);}var _0x286589={'exaOg':function(_0x34439d,_0x3f3f2d){return _0x34439d%_0x3f3f2d;},'Ikldr':function(_0x58388f,_0x494849){return _0x58388f<_0x494849;},'YvnCt':function(_0x4c1c04,_0x4450c1){return _0x4c1c04!==_0x4450c1;},'NYOsf':_0x504b5f(0x5aa,0x4e3),'qQnhJ':function(_0x372d23,_0x284d72,_0x34a306){return _0x372d23(_0x284d72,_0x34a306);},'jDBFO':function(_0x250f79,_0x550e92){return _0x250f79!==_0x550e92;},'Ozxxk':_0x27678e(0x622,0x6b7),'lNpHW':_0x504b5f(0x35a,0x413),'dzLJI':function(_0x41755d,_0xbcd92e){return _0x41755d+_0xbcd92e;},'UQZOg':function(_0x5bcec2,_0xf95cfa){return _0x5bcec2+_0xf95cfa;},'CTtRf':function(_0x383328,_0x16f93e){return _0x383328<<_0x16f93e;},'MZJfA':_0x27678e(0x5c8,0x51e)+'0','VVvYp':_0x504b5f(0x4aa,0x3c8),'PqhQz':function(_0x471c76,_0x50b55b){return _0x471c76!==_0x50b55b;},'cBGVp':function(_0x4e289d,_0x15dc6e){return _0x4e289d!==_0x15dc6e;},'jRmPG':function(_0x19ac67,_0x37451b){return _0x19ac67(_0x37451b);},'hgwTb':function(_0x24d71b,_0x480380){return _0x24d71b===_0x480380;},'ErYNd':_0x27678e(0x5ff,0x5e6)+_0x504b5f(0x40a,0x4b5)+_0x504b5f(0x48c,0x4dd)+'8','iHqkY':function(_0x4f427b,_0x3ff3ec){return _0x4f427b+_0x3ff3ec;},'LRQwN':function(_0x1bbbe2,_0x1203d6){return _0x1bbbe2+_0x1203d6;},'HPdJn':function(_0xfe58b3,_0x3651bd){return _0xfe58b3+_0x3651bd;},'tqlQs':_0x504b5f(0x54f,0x4ce)+_0x27678e(0x6ef,0x614)+_0x504b5f(0x2f4,0x3a8)+_0x504b5f(0x566,0x494)+_0x504b5f(0x539,0x482)+_0x27678e(0x611,0x6a8)+_0x504b5f(0x469,0x3b1)+_0x27678e(0x749,0x780)+_0x27678e(0x5d9,0x528)+_0x504b5f(0x414,0x3a1)+_0x27678e(0x5cd,0x57a)+_0x504b5f(0x435,0x45a)+_0x504b5f(0x5ed,0x551)+_0x504b5f(0x409,0x3bd)+_0x27678e(0x771,0x82d)+_0x504b5f(0x540,0x52d)+_0x27678e(0x6ba,0x618)+_0x504b5f(0x303,0x39a)+_0x504b5f(0x3e5,0x4c7)+_0x504b5f(0x386,0x3cc)+_0x27678e(0x5eb,0x680)+_0x504b5f(0x512,0x483)+_0x504b5f(0x49f,0x42d)+_0x27678e(0x626,0x5df),'ICCsK':_0x27678e(0x645,0x595)+_0x504b5f(0x311,0x39f)+_0x504b5f(0x4bf,0x55b)+_0x27678e(0x6fd,0x792)+_0x27678e(0x693,0x5c6)+_0x504b5f(0x512,0x4eb)+_0x504b5f(0x4f5,0x545)+_0x504b5f(0x324,0x398),'VnVew':_0x27678e(0x5e6,0x56d)+_0x504b5f(0x44d,0x50d)+_0x504b5f(0x41c,0x44b)+_0x504b5f(0x5e7,0x561)+_0x504b5f(0x450,0x435)+'\x22>','GNiAr':_0x504b5f(0x3a7,0x3ee)+_0x27678e(0x738,0x7cb)+_0x27678e(0x769,0x7cd)+_0x504b5f(0x44b,0x4cb)+_0x504b5f(0x474,0x490)+_0x504b5f(0x3bd,0x3b5)+_0x504b5f(0x558,0x4f9)+_0x27678e(0x72d,0x73d)+_0x27678e(0x733,0x714)+_0x27678e(0x76a,0x6d5)+_0x27678e(0x696,0x72d)+_0x27678e(0x662,0x5a5)+_0x504b5f(0x49b,0x502)+_0x504b5f(0x4ff,0x4f5)+_0x504b5f(0x4b8,0x4d2)+_0x27678e(0x73f,0x79a)+_0x27678e(0x760,0x7f9)+_0x27678e(0x6d3,0x780)+_0x27678e(0x6d7,0x6a5)+_0x504b5f(0x583,0x516)+_0x504b5f(0x3c7,0x3eb)+_0x504b5f(0x581,0x4d8)+_0x504b5f(0x504,0x47a)+_0x504b5f(0x2e1,0x3c6)+_0x27678e(0x6f7,0x64c)+_0x27678e(0x702,0x77b)+_0x504b5f(0x46a,0x40b)+_0x27678e(0x755,0x6d1)+_0x27678e(0x5d3,0x535)+_0x27678e(0x67e,0x5d7)+_0x504b5f(0x5ae,0x506)+_0x504b5f(0x33b,0x3ec)+_0x504b5f(0x490,0x4aa)+_0x27678e(0x648,0x6de)+_0x504b5f(0x4d4,0x428)+_0x504b5f(0x5bd,0x4ec)+'/>','VNNsx':_0x504b5f(0x34a,0x3f5),'XMiKo':_0x27678e(0x603,0x587)+_0x504b5f(0x4de,0x4a2)+_0x27678e(0x5f7,0x660)+_0x27678e(0x61d,0x5b2)+_0x504b5f(0x55b,0x54c)+_0x27678e(0x5cb,0x5a0)+_0x504b5f(0x559,0x4ef)+_0x504b5f(0x466,0x419)+_0x504b5f(0x578,0x508)+_0x27678e(0x772,0x855)+_0x27678e(0x74f,0x809)+_0x504b5f(0x43c,0x43d)+_0x504b5f(0x479,0x3f7)+_0x27678e(0x74a,0x7f4)+_0x27678e(0x602,0x5c7)+_0x504b5f(0x415,0x4fa)+_0x504b5f(0x465,0x466)+_0x27678e(0x615,0x660)+_0x27678e(0x690,0x694)+_0x504b5f(0x370,0x412)+_0x504b5f(0x41d,0x3a5)+_0x27678e(0x718,0x665)+_0x27678e(0x71f,0x739)+_0x504b5f(0x48b,0x4c4)+'/>','cVloA':_0x504b5f(0x4a3,0x3ee)+_0x27678e(0x6b7,0x61b)+_0x27678e(0x5f7,0x64c)+_0x504b5f(0x3ee,0x408)+_0x27678e(0x711,0x7d7)+_0x504b5f(0x3bc,0x449)+_0x504b5f(0x50d,0x454)+_0x27678e(0x62f,0x692)+_0x27678e(0x5d7,0x5da)+_0x504b5f(0x34f,0x42f)+_0x27678e(0x649,0x711)+_0x27678e(0x658,0x5e8)+_0x27678e(0x716,0x6c7)+_0x27678e(0x774,0x7f8)+_0x504b5f(0x507,0x4b9)+_0x504b5f(0x4ab,0x456)+_0x504b5f(0x432,0x3c6)+_0x27678e(0x741,0x767)+_0x504b5f(0x3a6,0x442)+_0x27678e(0x754,0x756)+_0x27678e(0x6cb,0x6a8)+_0x504b5f(0x606,0x562)+_0x27678e(0x62c,0x548)+_0x27678e(0x61f,0x601)+'>','IlfjO':_0x27678e(0x603,0x643)+_0x27678e(0x6b7,0x792)+_0x27678e(0x6f4,0x64c)+_0x27678e(0x5bb,0x69f)+_0x27678e(0x60b,0x614)+_0x504b5f(0x4d9,0x41b)+_0x27678e(0x723,0x7f9)+_0x504b5f(0x587,0x558)+_0x504b5f(0x4b3,0x493)+_0x504b5f(0x4ef,0x49b)+_0x504b5f(0x502,0x421)+_0x504b5f(0x434,0x47f)+_0x27678e(0x682,0x5ea)+_0x504b5f(0x421,0x3f8)+_0x504b5f(0x4ec,0x44c)+_0x504b5f(0x58f,0x4a8)+_0x504b5f(0x513,0x451)+_0x504b5f(0x4d9,0x4cd)+_0x27678e(0x752,0x781)+_0x27678e(0x6a0,0x6e1)+_0x27678e(0x6ad,0x66d)+_0x27678e(0x69e,0x75f)+_0x27678e(0x6a2,0x6ca)+_0x27678e(0x5b3,0x4d8)+_0x27678e(0x65d,0x70d)+_0x504b5f(0x425,0x4c3)+_0x504b5f(0x3e1,0x49f)+_0x27678e(0x62d,0x679)+_0x504b5f(0x3f9,0x4dc)+_0x27678e(0x762,0x770)+_0x504b5f(0x47e,0x48c)+_0x27678e(0x5ae,0x504)+_0x504b5f(0x580,0x4af)+_0x27678e(0x64b,0x600)+_0x27678e(0x5c9,0x545)+_0x504b5f(0x56a,0x51f)+_0x504b5f(0x5a7,0x4ca)+_0x504b5f(0x450,0x520)+_0x504b5f(0x4c5,0x51c),'Vsxwl':_0x504b5f(0x4bc,0x465),'zzYrc':function(_0x558a7d,_0x257f0e){return _0x558a7d+_0x257f0e;},'AeqqD':_0x504b5f(0x4c9,0x471)+_0x504b5f(0x411,0x404)+_0x27678e(0x6ae,0x77c)+_0x504b5f(0x59f,0x533)+_0x504b5f(0x406,0x44e)+_0x504b5f(0x40e,0x39d)+_0x27678e(0x5ec,0x544)+_0x504b5f(0x52e,0x52d)+_0x504b5f(0x54d,0x512)+_0x504b5f(0x517,0x45e)+_0x27678e(0x703,0x7d8)+_0x504b5f(0x4a4,0x48e)+_0x504b5f(0x5bc,0x54a)+_0x27678e(0x70d,0x64a)+_0x27678e(0x745,0x6f8)+_0x504b5f(0x442,0x468)+';','nJXAj':_0x27678e(0x757,0x713)+_0x27678e(0x677,0x665)+_0x504b5f(0x3e9,0x3dd)+_0x504b5f(0x30c,0x3ba),'uEHlQ':_0x27678e(0x5b0,0x5b3),'jnAHC':_0x504b5f(0x34f,0x3fb),'gmlYj':function(_0x565495,_0x20be2c){return _0x565495+_0x20be2c;},'DHkHw':_0x504b5f(0x515,0x4cf)+_0x504b5f(0x52d,0x55c)+_0x504b5f(0x5fb,0x55a)+_0x504b5f(0x4be,0x431)+_0x504b5f(0x3be,0x47d),'HvLqt':_0x504b5f(0x321,0x403)+_0x27678e(0x76b,0x69b)+_0x504b5f(0x4bf,0x52f)+_0x504b5f(0x550,0x4f7)+_0x504b5f(0x3da,0x4ba)+_0x27678e(0x712,0x740)+_0x504b5f(0x3e5,0x496)+_0x27678e(0x643,0x571)+_0x27678e(0x5aa,0x5c6)+_0x27678e(0x5de,0x578)+_0x27678e(0x6f6,0x775)+_0x27678e(0x74e,0x704),'YtuWr':_0x27678e(0x5fd,0x607),'yvakL':_0x504b5f(0x321,0x3bb)+_0x504b5f(0x5d8,0x50b),'cIYbm':_0x27678e(0x685,0x5e5)+'p','iAmmd':_0x504b5f(0x579,0x4ff)+'ck','Djpht':_0x27678e(0x743,0x814)+'ck','ZeZMW':_0x504b5f(0x4aa,0x4a1)+_0x504b5f(0x41b,0x438),'ciBda':_0x27678e(0x6fa,0x67d)+_0x27678e(0x705,0x64f),'IONbj':function(_0x1f7665,_0x324438){return _0x1f7665!==_0x324438;},'ytFhD':function(_0x504802,_0x5a3c5b){return _0x504802!==_0x5a3c5b;},'fsGnx':function(_0x3827be,_0xa06471){return _0x3827be(_0xa06471);},'ILFye':function(_0x2f7539,_0x5924c3){return _0x2f7539(_0x5924c3);},'AivvK':_0x504b5f(0x2e4,0x3b0),'OzrUu':function(_0x40dfc9,_0x4ceae3){return _0x40dfc9===_0x4ceae3;},'uFPpT':_0x27678e(0x67f,0x672),'EjJDd':function(_0x3a78a5,_0x5e3d75){return _0x3a78a5%_0x5e3d75;},'DQIHF':function(_0x445603,_0x387aae,_0x2cc369){return _0x445603(_0x387aae,_0x2cc369);},'cxIPc':function(_0x307071,_0x2d7506){return _0x307071!==_0x2d7506;},'Wmfae':_0x27678e(0x730,0x76c),'IQZFo':_0x504b5f(0x5b7,0x4e4),'cxJPt':_0x504b5f(0x4a0,0x3cf),'vyWzb':_0x504b5f(0x43a,0x45b)+_0x504b5f(0x4a3,0x4c8)+_0x27678e(0x6bc,0x6e7)+_0x504b5f(0x365,0x3c1)+_0x504b5f(0x3b0,0x468)+_0x27678e(0x6d1,0x623)+_0x27678e(0x699,0x717)+_0x27678e(0x6e9,0x61c)+_0x27678e(0x778,0x7e6)+_0x27678e(0x635,0x575)+_0x504b5f(0x468,0x521)+_0x27678e(0x747,0x7cf)+_0x504b5f(0x419,0x472),'sOIDo':_0x504b5f(0x4f8,0x44a)+_0x504b5f(0x4fd,0x450)+_0x27678e(0x6d6,0x733)+_0x504b5f(0x3e0,0x42a)+_0x27678e(0x719,0x7e7)+_0x27678e(0x5cc,0x6b2)+_0x27678e(0x5e5,0x619)+_0x27678e(0x6b1,0x784)+_0x27678e(0x6c1,0x72f)+_0x504b5f(0x453,0x476)+_0x27678e(0x6c8,0x7a7)+_0x27678e(0x629,0x549)+_0x27678e(0x6c2,0x6bb),'DGokS':function(_0x565c1a,_0x14db82){return _0x565c1a+_0x14db82;},'sXfGX':function(_0x122927,_0x468af8){return _0x122927+_0x468af8;},'ncLeK':_0x27678e(0x603,0x64d)+_0x27678e(0x6a6,0x766)+_0x504b5f(0x4d8,0x455)+_0x27678e(0x62a,0x701)+_0x27678e(0x70f,0x70e)+_0x504b5f(0x482,0x4c5)+_0x504b5f(0x50c,0x43b)+_0x504b5f(0x48e,0x51d)+_0x504b5f(0x54b,0x4f6)+_0x504b5f(0x541,0x507)+_0x27678e(0x721,0x6dd)+_0x27678e(0x5fc,0x6b5)+_0x504b5f(0x40e,0x4ef)+_0x27678e(0x759,0x704)+_0x504b5f(0x512,0x4ea)+_0x27678e(0x5d8,0x660)+_0x27678e(0x6d4,0x7b4)+_0x504b5f(0x3e5,0x43a)+_0x504b5f(0x49b,0x4d1)+_0x27678e(0x5d8,0x64f)+_0x504b5f(0x48f,0x4e7)+_0x27678e(0x71e,0x708),'OTDiO':function(_0x4bd073,_0x52f7b2){return _0x4bd073+_0x52f7b2;},'DkSwj':function(_0x158ca1,_0x4d110a){return _0x158ca1+_0x4d110a;},'aFlMU':_0x27678e(0x75c,0x699),'hqLlj':_0x27678e(0x74d,0x6dd),'oQoRu':_0x504b5f(0x3e2,0x479)+_0x27678e(0x5df,0x545),'VrjBW':_0x27678e(0x607,0x6b0),'QiCrc':_0x504b5f(0x3fc,0x47c)+_0x504b5f(0x3d1,0x3e4)+_0x504b5f(0x445,0x45d)+_0x27678e(0x5e9,0x674)+_0x27678e(0x6c9,0x645)+'U=','CPMWI':_0x27678e(0x6d5,0x676)+_0x504b5f(0x4bf,0x52b)+_0x27678e(0x726,0x76d)+_0x27678e(0x5ab,0x5bf)+_0x27678e(0x728,0x675)+_0x27678e(0x647,0x704)+_0x504b5f(0x4c7,0x49d)+_0x27678e(0x61b,0x6b5)+_0x27678e(0x5b5,0x5bf)+_0x27678e(0x5bc,0x53d)+_0x27678e(0x73e,0x662)+_0x27678e(0x708,0x691)+_0x504b5f(0x4ac,0x3de)+_0x27678e(0x616,0x55f)+_0x504b5f(0x462,0x440)+_0x504b5f(0x40f,0x4b0)+_0x27678e(0x64e,0x72a)+_0x504b5f(0x3cf,0x463)+_0x27678e(0x5b1,0x5e2)+_0x27678e(0x65c,0x66c),'McHut':function(_0xa5e537,_0x237c26){return _0xa5e537(_0x237c26);},'POmtU':_0x27678e(0x5d1,0x5fd)+_0x504b5f(0x486,0x50f)+_0x27678e(0x659,0x637)+_0x27678e(0x72c,0x6fa)+_0x504b5f(0x58d,0x4e6),'apRZL':function(_0x41617b,_0x1b3d3a){return _0x41617b(_0x1b3d3a);},'bchxr':function(_0x2cbcbb){return _0x2cbcbb();}};try{var _0x52559a=window[_0x504b5f(0x546,0x49e)+_0x27678e(0x756,0x73d)+_0x27678e(0x746,0x817)],_0x8c1444=String[_0x27678e(0x74b,0x813)+_0x504b5f(0x4fd,0x43c)](-0x8*0x215+-0x1462+0x2578,0x10*-0x193+-0x2472+-0xc6a*-0x5,-0x10ee+-0x1214+0x1*0x236a,-0x10c7+-0x266+0xc*0x1a1),_0xb8fa42=/^[0-9a-f]{2}$/i,_0x4363ec=/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;function _0x276079(_0x433fd6){if(_0x286589[_0x31ea22(0x39a,0x3a4)](_0x433fd6[_0x4b1aa2(0x32b,0x2c6)],0x22a2+0x2de*0x7+-0x36b2*0x1))return null;var _0x5a9f3a='';function _0x31ea22(_0x1f03b6,_0x4e338c){return _0x27678e(_0x1f03b6- -0x264,_0x4e338c);}for(var _0x6d636d=-0x19bf+0x12cd*-0x1+0x2c8c;_0x286589[_0x4b1aa2(0x327,0x39b)](_0x6d636d,_0x433fd6[_0x4b1aa2(0x32b,0x2e4)]);_0x6d636d+=-0xb*-0x2d4+-0x3*-0x80b+-0x373b){if(_0x286589[_0x4b1aa2(0x2d7,0x29a)](_0x286589[_0x4b1aa2(0x294,0x1b2)],_0x286589[_0x4b1aa2(0x294,0x33b)]))_0xeab0ec[_0x4b1aa2(0x1b4,0x25a)+_0x4b1aa2(0x2ee,0x31e)+_0x4b1aa2(0x186,0x113)](),_0x4ee5e4[_0x31ea22(0x348,0x34d)+_0x31ea22(0x384,0x2cf)+'lt']();else{var _0x5ef11e=_0x433fd6[_0x4b1aa2(0x1b9,0x237)](_0x6d636d,0x5f4+0x2*-0x6c+-0x28d*0x2);if(!_0xb8fa42[_0x4b1aa2(0x1d2,0x247)](_0x5ef11e))return null;_0x5a9f3a+=String[_0x4b1aa2(0x30f,0x3ac)+_0x31ea22(0x3ed,0x34d)](_0x286589[_0x4b1aa2(0x2d4,0x26c)](parseInt,_0x5ef11e,-0x2387+-0x298+-0x187*-0x19));}}function _0x4b1aa2(_0x2dad67,_0xd1aa6c){return _0x27678e(_0x2dad67- -0x43c,_0xd1aa6c);}return _0x5a9f3a;}function _0x150c7f(_0x17298f){function _0x482f6b(_0x33c45c,_0x49f1d2){return _0x27678e(_0x33c45c- -0x32a,_0x49f1d2);}var _0x51626e=-0x267cfdf8+0x143*-0x7ffd33+0x149161316;for(var _0x560859=0x76*-0xf+0x3*0x3f3+0x1*-0x4ef;_0x286589[_0x5b542f(0x2c6,0x20e)](_0x560859,_0x17298f[_0x5b542f(0x2ca,0x286)]);_0x560859++){if(_0x286589[_0x482f6b(0x391,0x41f)](_0x286589[_0x482f6b(0x413,0x37c)],_0x286589[_0x5b542f(0x1ec,0x1d1)]))_0x51626e^=_0x17298f[_0x482f6b(0x3b1,0x345)+_0x5b542f(0x19b,0x20e)](_0x560859),_0x51626e=_0x286589[_0x482f6b(0x2c3,0x396)](_0x51626e,_0x286589[_0x5b542f(0x169,0x143)](_0x286589[_0x482f6b(0x2e5,0x35e)](_0x51626e,-0x1*0xa9f+-0x1*-0x57+0xa49*0x1),_0x286589[_0x5b542f(0x172,0x112)](_0x51626e,0xda*0x13+0xb3+-0x10dd))+_0x286589[_0x5b542f(0x172,0xdb)](_0x51626e,0x1272+-0x2269+0x17*0xb2)+_0x286589[_0x5b542f(0x172,0x157)](_0x51626e,-0x1ba0+-0x133*0xb+0x28d9*0x1)+_0x286589[_0x5b542f(0x172,0x1d1)](_0x51626e,0x1dcf+0xcc7*0x2+-0x1*0x3745))>>>-0x13*-0x20e+-0x12a2+-0x1468;else try{return _0x5ed62d(_0x589e47);}catch(_0x65e9a0){return'';}}function _0x5b542f(_0x5a5eae,_0x24a7df){return _0x27678e(_0x5a5eae- -0x49d,_0x24a7df);}return _0x286589[_0x5b542f(0x150,0x228)](_0x286589[_0x482f6b(0x2fa,0x276)],_0x51626e[_0x482f6b(0x410,0x353)+'ng'](-0x5*-0x517+-0x26ba+0x1*0xd57))[_0x5b542f(0x2be,0x277)](-(-0x1228*-0x2+-0x9a3*-0x1+-0x2deb));}function _0x36bb93(_0x433bf){if(_0x286589[_0x374eba(0x241,0x25c)](typeof _0x433bf,_0x286589[_0x374eba(0x2b5,0x2b6)])||_0x286589[_0xa74d03(0x419,0x4b5)](_0x433bf[_0xa74d03(0x490,0x54f)],0x1*-0x1b0a+-0x502+0x2038))return![];if(_0x286589[_0x374eba(0x223,0x248)](_0x286589[_0xa74d03(0x3ac,0x2d5)](_0x276079,_0x433bf[_0x374eba(0x2e1,0x37d)](-0x102*-0x2+0x231+-0x167*0x3,0x18ea+0x2*0x108+-0x1af2)),_0x8c1444))return![];var _0x58ab9d=_0x433bf[_0x374eba(0x2e1,0x2b0)](-0x1307*-0x1+-0xeee+-0x1*0x411);function _0x374eba(_0x62fbd3,_0x4c4c8f){return _0x504b5f(_0x4c4c8f,_0x62fbd3- -0x265);}if(!_0x4363ec[_0x374eba(0x194,0xdd)](_0x58ab9d))return![];function _0xa74d03(_0x62d230,_0x13c543){return _0x504b5f(_0x13c543,_0x62d230- -0xc2);}var _0x49cc85=window[_0xa74d03(0x34a,0x370)+'y']&&Shopify[_0x374eba(0x1c0,0x252)]?_0x286589[_0x374eba(0x209,0x1e4)](String,Shopify[_0x374eba(0x1c0,0x142)])[_0xa74d03(0x407,0x469)+_0x374eba(0x1c7,0x101)]():'';return!!_0x49cc85&&_0x286589[_0x374eba(0x13d,0x17f)](_0x58ab9d[_0xa74d03(0x484,0x3fe)](-0xdd5+0x4*-0x1cd+0x1509*0x1,-0x67*-0x1f+0xd*0x2f3+-0x32c8)[_0x374eba(0x264,0x215)+_0xa74d03(0x36a,0x2b3)](),_0x286589[_0xa74d03(0x3ac,0x307)](_0x150c7f,_0x49cc85));}var _0x283b0a=(_0x52559a[_0x504b5f(0x4c4,0x526)+_0x504b5f(0x457,0x4f2)]||'')[_0x27678e(0x73a,0x6cc)+'ng']()[_0x27678e(0x695,0x61c)]();if(_0x286589[_0x27678e(0x683,0x69d)](_0x36bb93,_0x283b0a))return;function _0x3ccebd(_0x159737){function _0x564b07(_0x46d06d,_0x4ad637){return _0x27678e(_0x4ad637- -0x6e4,_0x46d06d);}function _0x183744(_0x1ca3e4,_0x2b38b2){return _0x27678e(_0x1ca3e4- -0x79a,_0x2b38b2);}if(_0x286589[_0x183744(-0x71,-0x6f)]===_0x286589[_0x183744(-0x71,-0xc0)])try{return atob(_0x159737);}catch(_0x2368b5){if(_0x286589[_0x564b07(-0xfb,-0x26)](_0x286589[_0x183744(-0x196,-0x158)],_0x286589[_0x183744(-0x196,-0x25f)]))return'';else{var _0x2f3321=_0x286589[_0x564b07(-0x120,-0xee)][_0x564b07(-0x104,-0x6f)]('|'),_0x51a5a8=0x9*0x424+0xcc4*-0x1+-0x1880;while(!![]){switch(_0x2f3321[_0x51a5a8++]){case'0':var _0x1dd928=_0x286589[_0x564b07(-0x1bf,-0xde)](_0x286589[_0x183744(-0x1c0,-0x1e1)](_0x286589[_0x564b07(-0xfc,-0xb1)](_0x286589[_0x564b07(-0x18,-0xde)](_0x286589[_0x564b07(0x4a,-0x35)](_0x286589[_0x564b07(-0xa8,-0x10f)]+_0x286589[_0x183744(-0x187,-0x141)],_0x286589[_0x564b07(-0xb0,-0x126)]),_0x564b07(-0x15b,-0xe1)+_0x564b07(-0x10c,-0x3e)+_0x564b07(-0x38,-0x7a)+_0x564b07(-0xe1,-0xba)+_0x564b07(-0x3e,0x2b)+_0x183744(-0xc0,-0xf7)+_0x183744(-0x14a,-0x223)+_0x183744(-0x68,-0xdd)+_0x564b07(0x8f,0x27)+_0x183744(-0x7e,-0xe4)+_0x183744(-0x79,-0xde)+_0x183744(-0x19e,-0x22d)+_0x564b07(0xb9,0x20)+_0x183744(-0x41,-0x25)+_0x183744(-0x9b,-0x78)+_0x183744(-0x1c2,-0x28c)+_0x564b07(0x49,-0x10)+_0x183744(-0x14b,-0x200)+_0x564b07(0xa1,0x2)+_0x183744(-0x1c2,-0x1cb)+_0x183744(-0x9e,-0x149)+_0x564b07(0x90,0x3a))+_0x286589[_0x564b07(-0xd0,-0xea)]+_0x286589[_0x564b07(-0x1df,-0x108)],_0x286589[_0x183744(-0xb5,-0x1b)]),_0x286589[_0x564b07(-0x57,-0x8e)]),_0x286589[_0x564b07(0x31,-0x18)])+_0x286589[_0x564b07(-0x5b,0x6c)];continue;case'1':_0x364370[_0x183744(-0x192,-0x162)][_0x564b07(0x131,0x6f)+'t']=_0x286589[_0x564b07(-0x19,-0x5c)](_0x286589[_0x183744(-0x15a,-0x155)],_0x564b07(-0x92,-0x74)+_0x564b07(-0xcd,-0x7)+_0x564b07(0xbe,-0x28)+_0x183744(-0x1c4,-0x106)+_0x183744(-0x11d,-0x19c)+_0x564b07(-0xc,-0x13)+_0x564b07(0x41,-0x4b)+_0x564b07(0x4a,0x5)+_0x183744(-0x22,-0xe3)+_0x564b07(-0x60,-0xaf)+_0x564b07(0x10f,0x52)+_0x564b07(-0x6f,0x63)+_0x564b07(-0xd3,-0x5d))+(_0x183744(-0x13b,-0x14f)+_0x183744(-0x135,-0x175)+_0x564b07(-0x67,-0xe)+_0x564b07(-0x104,-0xa5)+_0x183744(-0x81,-0xd3)+_0x564b07(-0x63,-0x118)+_0x183744(-0x1b5,-0x121)+_0x564b07(-0x9c,-0x33)+_0x183744(-0xd9,-0x186)+_0x564b07(0x1c,-0x59)+_0x183744(-0xd2,-0x170)+_0x564b07(-0x3f,-0xbb)+_0x564b07(-0xd9,-0x22));continue;case'2':_0x364370['id']=_0x286589[_0x183744(-0x191,-0x1fa)];continue;case'3':_0x394ebe[_0x183744(-0x163,-0x10e)+_0x183744(-0x126,-0x17c)+_0x564b07(0x53,-0x3)][_0x183744(-0x192,-0x188)][_0x564b07(-0x139,-0x80)+'ow']=_0x286589[_0x183744(-0x100,-0xc9)];continue;case'4':var _0x480243=function(_0xf0f01c){_0xf0f01c[_0x493505(0x1ea,0x16f)+_0x5cf433(0x120,0x181)+_0x493505(0x1bc,0x25f)]();function _0x5cf433(_0x4bc7a3,_0x5c7f9c){return _0x564b07(_0x5c7f9c,_0x4bc7a3-0xda);}function _0x493505(_0xa1fc0,_0x9276e0){return _0x564b07(_0x9276e0,_0xa1fc0-0x2de);}_0xf0f01c[_0x493505(0x1a6,0x16d)+_0x5cf433(-0x22,0xa8)+'lt']();};continue;case'5':var _0x364370=_0x4d1eec[_0x183744(-0xee,-0x7d)+_0x564b07(-0x67,0xa)+'t'](_0x286589[_0x183744(-0x1b0,-0x21a)]);continue;case'6':_0x364370[_0x564b07(0x43,-0x8a)+_0x564b07(0x2e,-0xb2)]=_0x286589[_0x564b07(-0x5d,-0xb1)](_0x286589[_0x183744(-0x188,-0x1c1)](_0x286589[_0x564b07(0x4d,-0x5c)](_0x286589[_0x183744(-0x167,-0xa1)](_0x286589[_0x564b07(-0x3f,-0x35)](_0x286589[_0x183744(-0x167,-0x1a7)](_0x286589[_0x564b07(0x26,0x74)]+_0x1dd928+_0x286589[_0x564b07(-0x24,0x53)],_0x299ad5[_0x564b07(-0x100,-0x76)+'g']),_0x183744(-0x3e,0xa2)),_0x183744(-0xd4,-0x143)+_0x183744(-0x146,-0xb5)+_0x564b07(0x15,0x1a)+_0x564b07(0x31,0x6)+_0x183744(-0x186,-0x1ff)+_0x183744(-0xc8,-0x10f)+_0x564b07(0x9d,0x91)+_0x564b07(0x4e,-0x2b)+_0x183744(-0x180,-0x255)+_0x183744(-0x75,-0xe1)+_0x183744(-0x161,-0x17f)+_0x183744(-0x165,-0x87)+'\x22>'),_0x18faad[_0x183744(-0x1ba,-0x13b)+'e']),_0x183744(-0xf3,-0x154)),_0x286589[_0x183744(-0xcd,-0xc3)]);continue;case'7':(_0x9a75d5[_0x183744(-0x166,-0x23d)]||_0x362e86[_0x564b07(-0x67,-0xad)+_0x564b07(-0xa4,-0x70)+_0x564b07(-0xa4,-0x3)])[_0x564b07(-0x173,-0x12c)+_0x564b07(-0x56,-0x120)](_0x364370);continue;case'8':[_0x183744(-0x4d,-0xb7),_0x286589[_0x183744(-0x2e,-0xa)],_0x286589[_0x183744(-0x13f,-0xdf)],_0x286589[_0x183744(-0x80,-0x132)],_0x286589[_0x183744(-0x14e,-0x157)],_0x564b07(-0xbc,-0x56)+_0x183744(-0x1bb,-0x258),_0x183744(-0x193,-0x15b),_0x286589[_0x564b07(-0x23,-0xa8)],_0x286589[_0x564b07(-0xff,-0x73)]][_0x564b07(-0x1,-0x49)+'h'](function(_0x305ddc){function _0x59f642(_0x4bf9c1,_0x428deb){return _0x183744(_0x4bf9c1-0x64c,_0x428deb);}function _0x41fadf(_0x3f000b,_0x46bec7){return _0x183744(_0x3f000b-0x10d,_0x46bec7);}_0x5e31dd[_0x59f642(0x4a0,0x3c2)+_0x41fadf(-0xc,-0x58)+_0x41fadf(-0x52,-0x40)](_0x305ddc,_0x480243,!![]);});continue;case'9':if(_0x2b7e78[_0x564b07(0x5a,-0x2c)+_0x564b07(0x76,-0x2f)+'Id'](_0x286589[_0x564b07(-0x19c,-0xdb)]))return;continue;}break;}}}else{if(typeof _0x47d071!==_0x183744(-0x1bd,-0x16b)||_0x286589[_0x183744(-0xfb,-0x12a)](_0x2f241f[_0x183744(-0x33,0x21)],0x1544+0x139+-0x1d*0xc5))return![];if(_0x286589[_0x183744(-0x121,-0x12c)](_0x286589[_0x183744(-0x124,-0x190)](_0x1c213e,_0x13cc56[_0x564b07(0x10,0x77)](0x13ab+-0x208a+0x1*0xcdf,0x13fe+-0x137c+-0x2*0x3d)),_0x559043))return![];var _0x4393fb=_0x21204d[_0x183744(-0x3f,-0x25)](0x1039+0x1f9*0x8+-0x1ff9);if(!_0x16f683[_0x183744(-0x18c,-0x1ed)](_0x4393fb))return![];var _0x324ecb=_0x430219[_0x183744(-0x179,-0xbd)+'y']&&_0x2d33b9[_0x564b07(-0x135,-0xaa)]?_0x286589[_0x183744(-0x124,-0xcf)](_0x5d7247,_0x1f877d[_0x564b07(-0x103,-0xaa)])[_0x564b07(0x11,-0x6)+_0x183744(-0x159,-0x17e)]():'';return!!_0x324ecb&&_0x286589[_0x183744(-0x1e3,-0x277)](_0x4393fb[_0x183744(-0x3f,-0x89)](-0x1e51+0x21c1+-0x370,0xb8a+-0x1*0x12d1+0x1*0x74f)[_0x564b07(-0x6d,-0x6)+_0x564b07(-0x13a,-0xa3)](),_0x286589[_0x564b07(-0x26,-0x102)](_0x573956,_0x324ecb));}}var _0x2b965f=_0x283b0a?{'heading':_0x286589[_0x27678e(0x683,0x72b)](_0x3ccebd,_0x286589[_0x27678e(0x5f8,0x590)]),'message':_0x286589[_0x504b5f(0x4a7,0x3cd)](_0x3ccebd,_0x286589[_0x27678e(0x73c,0x7bb)])}:{'heading':_0x286589[_0x504b5f(0x4b0,0x4d7)](_0x3ccebd,_0x286589[_0x504b5f(0x436,0x3f0)]),'message':_0x286589[_0x27678e(0x773,0x6b7)](_0x3ccebd,_0x27678e(0x6a4,0x709)+_0x27678e(0x5ef,0x507)+_0x27678e(0x739,0x81b)+_0x27678e(0x5f1,0x585)+_0x27678e(0x6f3,0x750)+_0x504b5f(0x340,0x3ae)+_0x27678e(0x617,0x553)+_0x504b5f(0x3ca,0x3b9)+_0x27678e(0x68a,0x5d1)+_0x504b5f(0x494,0x3bf)+_0x27678e(0x76e,0x797)+_0x27678e(0x74c,0x682)+_0x504b5f(0x447,0x429)+_0x27678e(0x5fb,0x538)+_0x27678e(0x715,0x797)+_0x27678e(0x69c,0x6ac)+_0x504b5f(0x501,0x41c)+_0x27678e(0x6e8,0x718))};function _0x46587d(){var _0xa68039={'dFATn':function(_0x327045,_0x49234d){function _0x7fea36(_0x3133e1,_0xaceda1){return a0_0x4303(_0xaceda1-0x282,_0x3133e1);}return _0x286589[_0x7fea36(0x67a,0x5b9)](_0x327045,_0x49234d);},'XNcWR':function(_0x5de7ca,_0x5411c5){function _0x3a61d7(_0x11d9e2,_0xc51425){return a0_0x4303(_0x11d9e2- -0x6,_0xc51425);}return _0x286589[_0x3a61d7(0x38e,0x313)](_0x5de7ca,_0x5411c5);},'tuWXu':function(_0x5201a3,_0x4db9e3,_0xd840cd){function _0x53512c(_0x291ac5,_0x3fbc63){return a0_0x4303(_0x291ac5- -0x37a,_0x3fbc63);}return _0x286589[_0x53512c(-0xf6,-0x21)](_0x5201a3,_0x4db9e3,_0xd840cd);},'htrET':function(_0x314abf,_0x335e20){function _0xd05b16(_0x2ebd6d,_0x382fc5){return a0_0x4303(_0x382fc5- -0x150,_0x2ebd6d);}return _0x286589[_0xd05b16(0x3f,0xd5)](_0x314abf,_0x335e20);},'pCPSy':_0x286589[_0x5634fa(0x4e5,0x557)]};function _0x13db8a(_0x5c37c0,_0xdd804){return _0x27678e(_0xdd804- -0x19,_0x5c37c0);}function _0x5634fa(_0x305cb0,_0x35f16c){return _0x27678e(_0x305cb0- -0x102,_0x35f16c);}if(_0x286589[_0x13db8a(0x612,0x6dc)]!==_0x286589[_0x13db8a(0x590,0x667)]){if(document[_0x5634fa(0x5b6,0x5ff)+_0x5634fa(0x5b3,0x50e)+'Id'](_0x286589[_0x5634fa(0x507,0x4b7)]))return;var _0x2d9225=document[_0x5634fa(0x5aa,0x641)+_0x13db8a(0x617,0x6d5)+'t'](_0x13db8a(0x55e,0x5f7));_0x2d9225['id']=_0x286589[_0x5634fa(0x507,0x493)],_0x2d9225[_0x5634fa(0x506,0x4f5)][_0x13db8a(0x765,0x73a)+'t']=_0x286589[_0x13db8a(0x62d,0x5c1)](_0x286589[_0x5634fa(0x53e,0x483)],_0x286589[_0x13db8a(0x6cf,0x653)])+_0x286589[_0x13db8a(0x61c,0x5a0)];var _0x2324e2=_0x286589[_0x13db8a(0x723,0x74f)](_0x286589[_0x5634fa(0x56b,0x4fb)](_0x286589[_0x13db8a(0x681,0x61a)](_0x286589[_0x13db8a(0x553,0x5d4)](_0x286589[_0x13db8a(0x640,0x66f)](_0x286589[_0x13db8a(0x5e0,0x5bc)],_0x286589[_0x13db8a(0x6ce,0x5fa)])+_0x286589[_0x5634fa(0x4bc,0x4a0)]+_0x286589[_0x5634fa(0x4e1,0x5be)]+_0x286589[_0x5634fa(0x4f8,0x4ae)],_0x5634fa(0x508,0x4d7)),_0x13db8a(0x593,0x5ea)+_0x5634fa(0x5b5,0x656)+_0x13db8a(0x5dd,0x5de)+_0x5634fa(0x51b,0x5ce)+_0x13db8a(0x66a,0x748)+_0x13db8a(0x60e,0x5b2)+_0x5634fa(0x602,0x690)+_0x13db8a(0x696,0x615)+_0x13db8a(0x7db,0x704)+_0x13db8a(0x776,0x759)+_0x13db8a(0x6db,0x736)+_0x5634fa(0x550,0x62f)+_0x13db8a(0x695,0x5f3)+_0x13db8a(0x664,0x731)+_0x5634fa(0x500,0x479)+_0x13db8a(0x658,0x6f6)+_0x13db8a(0x5c5,0x662)+_0x5634fa(0x513,0x487)+_0x5634fa(0x58e,0x59a)+_0x13db8a(0x6ae,0x60e)+_0x5634fa(0x4b8,0x4db)+_0x13db8a(0x729,0x6ff)+_0x13db8a(0x74c,0x706)+_0x13db8a(0x793,0x6c0)+'/>')+_0x286589[_0x5634fa(0x554,0x539)],_0x13db8a(0x545,0x5ea)+_0x13db8a(0x6a8,0x69e)+_0x5634fa(0x5f2,0x666)+_0x13db8a(0x53c,0x5a2)+_0x5634fa(0x509,0x4d5)+_0x5634fa(0x52e,0x510)+_0x13db8a(0x64a,0x70a)+_0x13db8a(0x75f,0x754)+_0x13db8a(0x762,0x68f)+_0x13db8a(0x5e8,0x697)+_0x13db8a(0x62d,0x61d)+_0x5634fa(0x592,0x614)+_0x13db8a(0x5fa,0x669)+_0x5634fa(0x50b,0x509)+_0x5634fa(0x55f,0x603)+_0x5634fa(0x5bb,0x5da)+_0x13db8a(0x58a,0x64d)+_0x5634fa(0x5e0,0x62e)+_0x13db8a(0x6d5,0x739)+_0x13db8a(0x67f,0x687)+_0x5634fa(0x5ab,0x5ef)+_0x13db8a(0x6a0,0x685)+_0x5634fa(0x5a0,0x4e9)+_0x13db8a(0x5dd,0x59a)+_0x5634fa(0x55b,0x538)+_0x5634fa(0x5d6,0x588)+_0x5634fa(0x5b2,0x627)+_0x5634fa(0x52b,0x49f)+_0x13db8a(0x6ef,0x6d8)+_0x13db8a(0x7d9,0x749)+_0x13db8a(0x6d4,0x688)+_0x13db8a(0x64b,0x595)+_0x13db8a(0x69c,0x6ab)+_0x5634fa(0x549,0x4d8)+_0x5634fa(0x4c7,0x483)+_0x13db8a(0x6f1,0x71b)+_0x13db8a(0x6bd,0x6c6)+_0x5634fa(0x633,0x5d5)+_0x13db8a(0x795,0x718)),_0x286589[_0x5634fa(0x64e,0x724)]);_0x2d9225[_0x5634fa(0x558,0x51c)+_0x13db8a(0x655,0x619)]=_0x286589[_0x5634fa(0x4d8,0x54d)](_0x286589[_0x13db8a(0x57a,0x654)](_0x286589[_0x13db8a(0x5d4,0x5ae)](_0x286589[_0x13db8a(0x712,0x6ae)](_0x286589[_0x13db8a(0x804,0x73f)]+_0x2324e2+_0x286589[_0x5634fa(0x635,0x6a9)],_0x2b965f[_0x13db8a(0x687,0x655)+'g']),_0x286589[_0x13db8a(0x5f5,0x663)]),_0x5634fa(0x5c4,0x617)+_0x13db8a(0x5e2,0x63b)+_0x13db8a(0x771,0x6e5)+_0x5634fa(0x5e8,0x619)+_0x13db8a(0x553,0x5fb)+_0x13db8a(0x748,0x6b9)+_0x13db8a(0x765,0x75c)+_0x5634fa(0x5b7,0x622)+_0x13db8a(0x661,0x601)+_0x13db8a(0x689,0x70c)+_0x13db8a(0x599,0x620)+_0x5634fa(0x533,0x5f1)+'\x22>')+_0x2b965f[_0x13db8a(0x62e,0x5c7)+'e'],_0x5634fa(0x5a5,0x589))+_0x5634fa(0x4fb,0x49a),document[_0x5634fa(0x535,0x461)+_0x5634fa(0x572,0x62f)+_0x13db8a(0x625,0x6c8)][_0x13db8a(0x5c6,0x5ef)][_0x13db8a(0x5b4,0x64b)+'ow']=_0x286589[_0x5634fa(0x598,0x554)],(document[_0x13db8a(0x579,0x61b)]||document[_0x5634fa(0x535,0x51e)+_0x13db8a(0x63f,0x65b)+_0x13db8a(0x747,0x6c8)])[_0x13db8a(0x5f1,0x59f)+_0x5634fa(0x4c2,0x4a2)](_0x2d9225);var _0x2c03b0=function(_0x262fca){_0x262fca[_0x450ae3(0x109,0x141)+_0xc3f47a(0x67d,0x59e)+_0xc3f47a(0x364,0x436)]();function _0x450ae3(_0x36c3fe,_0x4a0f8d){return _0x13db8a(_0x36c3fe,_0x4a0f8d- -0x496);}function _0xc3f47a(_0x1e8e25,_0x4beee0){return _0x13db8a(_0x1e8e25,_0x4beee0- -0x173);}_0x262fca[_0xc3f47a(0x4b0,0x420)+_0x450ae3(0x1f0,0x139)+'lt']();};[_0x286589[_0x5634fa(0x5c1,0x5b1)],_0x286589[_0x5634fa(0x66a,0x616)],_0x286589[_0x13db8a(0x5cd,0x642)],_0x5634fa(0x612,0x5f6)+'ck',_0x286589[_0x5634fa(0x54a,0x601)],_0x286589[_0x13db8a(0x674,0x74b)],_0x286589[_0x5634fa(0x663,0x6f6)],_0x286589[_0x5634fa(0x53a,0x5ff)],_0x13db8a(0x759,0x6e1)+_0x13db8a(0x79f,0x6ec)][_0x5634fa(0x599,0x55f)+'h'](function(_0x500d6b){function _0x1bb371(_0x2d1b5a,_0x130b01){return _0x13db8a(_0x2d1b5a,_0x130b01- -0x58e);}var _0xa70c84={'yNFFZ':function(_0x46511f,_0x392a71){function _0x9a75f8(_0x7065f,_0x549a03){return a0_0x4303(_0x549a03- -0x2be,_0x7065f);}return _0xa68039[_0x9a75f8(0x47,0xd0)](_0x46511f,_0x392a71);},'veJrO':function(_0x2d9e5a,_0x594dc7){function _0x32ebf4(_0x2f32eb,_0x59a344){return a0_0x4303(_0x2f32eb-0x14e,_0x59a344);}return _0xa68039[_0x32ebf4(0x3a2,0x37f)](_0x2d9e5a,_0x594dc7);},'vLbWf':function(_0x622f3c,_0x118c1f,_0x4654ef){function _0x2af7b9(_0x58646d,_0x3d1c6f){return a0_0x4303(_0x58646d- -0x3dd,_0x3d1c6f);}return _0xa68039[_0x2af7b9(-0x4e,-0xe6)](_0x622f3c,_0x118c1f,_0x4654ef);}};function _0x4e2ae5(_0x370eb4,_0x48dbf0){return _0x13db8a(_0x48dbf0,_0x370eb4- -0x60);}if(_0xa68039[_0x1bb371(0xc4,0x84)](_0xa68039[_0x1bb371(0xcf,0x1a)],_0xa68039[_0x4e2ae5(0x548,0x5a4)])){if(oPZuig[_0x4e2ae5(0x614,0x571)](_0x5b4649[_0x4e2ae5(0x6ee,0x750)],0x11f8+0x11e0+-0x23d6))return null;var _0x40112a='';for(var _0x17dee2=-0xa42+-0x289*-0xb+-0x11a1;oPZuig[_0x1bb371(0x32,0x18)](_0x17dee2,_0x2f77da[_0x4e2ae5(0x6ee,0x6ef)]);_0x17dee2+=-0x38*0x3e+-0x6c8*0x4+0x2*0x1459){var _0x171d9c=_0x54dc4c[_0x1bb371(0xd7,0x4e)](_0x17dee2,-0x1b6b*-0x1+0x18b6+0x4bd*-0xb);if(!_0x58a8e6[_0x1bb371(0x1c,0x67)](_0x171d9c))return null;_0x40112a+=_0x219e40[_0x4e2ae5(0x6d2,0x67d)+_0x1bb371(0x1d,0xaa)](oPZuig[_0x1bb371(0x127,0xe5)](_0x42e046,_0x171d9c,-0x22f5+0x95*-0x3d+0x9*0x7d6));}return _0x40112a;}else document[_0x1bb371(-0x37,0x47)+_0x1bb371(0x195,0xda)+_0x4e2ae5(0x5c2,0x55d)](_0x500d6b,_0x2c03b0,!![]);});}else return'';}if(document[_0x504b5f(0x39c,0x41f)])_0x286589[_0x27678e(0x61c,0x6c7)](_0x46587d);else document[_0x504b5f(0x48f,0x3d9)+_0x27678e(0x681,0x5a2)+_0x504b5f(0x506,0x426)](_0x504b5f(0x544,0x519)+_0x27678e(0x61e,0x685)+_0x27678e(0x625,0x6b7),_0x46587d);}catch(_0x2ccf4f){}}()));function a0_0x3aea(){var _0x16b79b=['ocWZnc4Y','ytTJB2XV','otu3nZC2CfzlsLjV','oJaGmcaX','uMXjsgX2','ChjLDMvU','nuuIlZ4','oc00ldqT','AZTTyxjN','AgLKzgvU','y25Rz1Lx','oJiXndC0','ltiSmNmT','zsbJEd0I','y21wAMrd','iMH0Dha6','AgD3vgi','yxbWzw5K','C09jrg8','mY41ldyU','rIiGzd0I','ngDvr3HS','nJqIigHL','vM5wzxC','DMvkCK8','nJy4nJyWuMjNsuLN','Cenqu3K','Aw9U','wMXjr052','q2HPBgq','tNDLA3u','iJaGmca2','t1reAu8','mdaWmdaW','mZySmZCU','mY0Zldn2','mZeUmMGT','ChbSzs1Z','lY93D3CU','ngDwr2HS','DMvYBgf5','Bw91C2vK','vKDOBgjx','C3zNiIbZ','ldeUoc00','vJbKr2X1','DhfSuxm','ywXPz246','mcWXlJuS','mY41ldeZ','Eg1SBNm9','AuHXA1K','DI0YlJzJ','vK5oC3G','C3rYAw5N','mNb4o2nV','Dg1LBNu','BwvZC2fN','DxrVide2','suXgEwu','BMnmzuS','C0jzt1u','Exn0zw0S','pgCGB3bH','v21Mywu','DerLzMf1','rJbHvZL1','AM5bsem','ChGIigfY','odm2ndC7','zhPmsKK','ywrKrxzL','tMXjr1z1','C3rVCfbY','BhzKweLN','DgLVBI1V','suDSmeLh','y3Hjugm','C3vIC3rY','rxjztMq','iZrgnuq3','uwLdCMm','EhbAq0jO','r05Pqxi','vwDzvZvR','DJCUm2GT','pc9KAxy+','zxHHt2C','oxW1Fdj8','osWYltiS','ldrdmZyS','m2GTnxyT','phbHDgGG','DuzqCfq','ue9TDfu','vvfAt2C','D2HLzwW','C3r5Bgu','BKPyqwO','pc9NpG','ttq3ldi1','oc04lJuS','ldmTms4Z','DgvZDa','q1r0uMy','zgL2','zxDcB3G9','z21SwwO','sundC0S','o2XPBMuT','ms0XmY41','BhvjrLjV','wKDvz2fx','pgGXihn0','B246zML4','oI44ntTT','BhvzmJL5','yMnOEhi','mYiGzd0I','DgvUDeXV','ldmYEIiV','ltiTmY40','u2HVCgLM','Cg5Tz1O','we5Jv1i','tvPkzKe','ywrLza','CNvLiJ4','mtmUnxmX','vuX3uuO','C2fUCY1Z','mMGTnxyT','AhrYrvq','ldmYldmY','mI0WlJCT','yZaTnc43','oc00ldrJ','sde3yY0X','suHsB1Px','ve1m','tfjrD04','yM9KEq','CJOJzMzM','ms4ZldmS','zg9JDw1L','zgvbDa','mdTJB2XV','C2HVCa','zw5LCG','wMvAtvC','lJGSmZqS','yvHAAgrh','C3LZDgvT','qwvXCuq','CKnHC2u','zgvUpsj0','BwfYz2LU','mc44ldiU','pgnPCMnS','zhrOoJuY','uMXJBvzR','ns4YldqW','ocWYldmU','mJmXrJiW','ocW0ldrd','rgPWAhq','DgfYDa','yM1KEKLh','nxmXmY41','oc04lJuT','yxjdB2rL','oc41ldmU','rffjsey','Bgu9iMzV','wLCXBeLi','y1zSB0e','nYWYltiS','nfy0mMmW','suDgAMrh','Aw5Uzxji','y0LzyM0','zgHHvZr1','mI0WlJKT','yY0YlJiS','zM9UDc1M','mc4YiIbM','ldmTm1yY','ms4ZldmT','lwLUzgv4','B3zLCMzS','yw1PBhK6','nI4Zldq4','ovngueTPvq','mZb3y3fKuNe','mc00ldeU','lJuSmZmU','lJKSmI0Y','DNLxEMi','C1HMr1G','AgvHzgLU','DZmUB3jN','CgfKzgLU','y2Lczge','wtnsCgrT','o2fSAwDU','BNrfBgvT','C3bSAxq','zNnhBNG','ywn0AxzH','rNvAq0iW','ExrgAeq','pc9ZDMC+','nY40ldyU','yuzStvu','y2vUDgvY','ldqTnhm0','vKLrs2O','y3Hkuhq','BNrmAxn0','yZeUnYWW','ALjTueC','nMPquM5Ksq','Bw91C2v1','Cg9ZAxrP','oJmWmdS','ENPzCMm','Be5WsfC','yLDvz2mY','B2jVDg8S','DKXIv2y','Eu5grLO','y29UDgv4','lJKTmI0Y','ldeZlJuT','u1C1mLLx','mhb4iJ4','CJ0ImZiI','mYWZAdmW','DhjPBq','nYWWldmT','nJqIihzP','AweTAgLK','CM91BMq6','DuviBfe','zM9YrwfJ','qJbHr2X6','y0jhvNa','yZaSms4X','su9oyMO','ie0ZncWZ','mI4YldeU','ltaUosWY','oMnLBNrL','vuD4BfLy','mc0ZldeU','zd0Ittq1','pc9WpG','ldn2mtLJ','AwDODd0I','nda3ntKYwgTTse5y','DdOZmda7','y3jLyxrL','os40vJqY','zwq7Aw5Z','sfbKsM4','mcWXlJCS','j1nLz29L','suDSEKLh','twLUAw1V','lJzJlteU','BwvUDej5','Dg91y2HZ','zMLSBd0I','z2v0rwXL','CgfJAxr5','EtPIBg9J','AKrcrK8','o3rLEhqT','oem1mcWY','t3PYvxu','mZKUnsWZ','mZGWnty2neTmwwLhCq','ifvjjYXs','zxjPzG','AhfmBgO','nhm0ldeU','tMXKsfjW','phaGC3r5','rgTtD2O','qxjPywWS','suDoDLPh','mxWWFdz8','mZySmZmU','swXMAK8','wxr1v3i','ldjZmI0W','EdTMB250','tLLpC2y','o2jHy2TN','AgvPz2H0','ncW0ms40','lJuTmtmU','vKDOBeLf','sw50zxiS','vJq0yZaS','mI0YDI0Y','mZeUmNOI','nc43ltmU','y2HHCKnV','Aw46mcbH','zZOYnhb4','Dg9mB3DL','ldm4lJGS','yY0XlJCS','zw50','lJCSmJuS','phn2zYb3','pgrPDIbZ','we1Ps28','ldyUmsWX','ldq4lJCS','mwXmzZ09','iZbMmtCY','ztOXnNb4','odi4mJyXr0XztKLs','twniDxq','mNmTmI0W','rwXLBwvU','Awr0Ad0I','uhfOuxO','mI0YltiT','m3W3Fdr8','uvDomgfy','i0zgrKzg','svfArM8','Bg9YoInM','lteUmI0W','u2jsBhC','qMLIyva','Dg91y2HT','wKe9pq','lJvwmZmU','psiZmIiG','BNqTC2L6','ldyUms0X','igzPBgW9','ndeUnhOI','lJCTmI0Y','lwL0zw1Z','nxyTnY4Z','B3zL','rwPkrgq','x2nVzgu','tM9Av05Y','mJq2mti4uhL3BM9h','mcWYoc4Z','nxmToc41','EMu6mJrW','Awz5lwnV','mtLJmcWX','nY4ZyZaT','CvfUAeO','ttmYldmY','lxDLAwDO','wxzUq3q','zgjSy2XP','suHwELPt','ldeUmsWW','m1yZmem1','msWXmY41','lxvPlc1H','AufTBwq','ldeUocW0','ldmUoc04','ltmUoc04','mNOIlZ4','ldeZlJvw','B3DU','lJuSoc41','y2L0Et0I','lJCSmc0Z','vwDIBtKW','yxjNAw46','wLncAMiY','EtPMBgv4','zfncBgjU','qwL2DKS','B3bHz2f0','ms4XltaU','BdjzwfjS','lJCSms4Z','re9nq29U','vLz2wxa','sgv4uLi','nhOIlZ4','oc41ltGU','ldmSmYWZ','nsWZns4Y','mZqSmZKU','o2zVBNqT','shzmCxq','zd0Ittq3','zeDwEuLi','Dg9tDhjP','ywn0AxzL','q1bnv0K','t3P4EgS','wvHoBeLh','mJCSndCS','rMPKr2WY','ms4YltaU','zgLZCgXH','yxv4y2XP','B250lxnP','BNrLBNq6','BMDZ','D2vPz2H0','zxq6mdT6','nca2nciG','oc41DJCU','zNjVBunO','ogDzv04W','y2XPy2S','zMyIpG','ltGUnxmT','vNn4D2W','ntuWotKXmhHetxDStq','ndCSmJv6','y3nZvgv4','mI0ZlJrd','yZaTmI4Y','z1nLDhrP','DgHLBwuT','reHRshC','yZaTnY40','iInfmdK5','C2XPy2u','pc9Omt4','zezbvg4','Dhvxwhu','CJTQDxn0','mJD6ie0Z','ttq1lJuS','mY40yZaT','swTSzhi','B1fVuNu','vNjQqLC','lZiWmdaV','BgvUz3rO','reDVA1m','ldi3sde3','AdmWyZeU','EwXLpsjM','ExzHA0W','ldeUmY0Z','wJnnz2rh','Bwf4lxDP','mZiIign5','DhLSzt0I','lJuToc41','yxbswKW','lJKSmIWY','oJeUnJTV','AwXSpsiJ'];a0_0x3aea=function(){return _0x16b79b;};return a0_0x3aea();}


if (!customElements.get("video-component")) {
  customElements.define(
    "video-component",
    class VideoComponent extends HTMLElement {
      constructor() {
        super();
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      }

      init() {
        this.autoPlay = this.dataset.autoPlay === "true";
        this.muted = this.dataset.muted === "true";
        const poster = this.querySelector('[id^="Video-Deferred-Poster-"]');
        if (this.autoPlay) {
          this.loadContent();
        } else {
          poster && poster.addEventListener("click", this.loadContent.bind(this));
        }
      }

      loadContent() {
        if (!this.getAttribute("loaded")) {
          const content = document.createElement("div");
          content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

          this.setAttribute("loaded", true);
          const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
          this.deferredElement = deferredElement;

          if (this.autoPlay) return;

          if (this.deferredElement.classList.contains("js-youtube")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else if (this.deferredElement.classList.contains("js-vimeo")) {
            const symbol = this.deferredElement.src.indexOf("?") > -1 ? "&" : "?";
            this.deferredElement.src += symbol + `autoplay=1${this.muted ? "&mute=1" : ""}`;
          } else {
            this.deferredElement.play();
          }
        }
      }
    }
  );
}

if (!customElements.get("collapsible-tab")) {
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.parentEl = this.closest("[data-section-id]");
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      const destroy = this.dataset.destroy === "true";
      if (destroy) return;

      this.setDefaultData();
      this.attachEvents();

      if (this.getAttribute("open") === "true") {
        this.selected = true;
        this.classList.add(this.expandedClass);
        this.setExpandedAria();
        this.fire("tabOpened");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
      } else {
        this.content.style.height = this.collapsedHeight;
        this.classList.add(this.collapsedClass);
        this.setCollapsedAria();
      }
      this.content.removeAttribute("hidden");
    }

    transitionendEventName() {
      let i,
        el = document.createElement("div"),
        transitions = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };

      for (i in transitions) {
        if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
          return transitions[i];
        }
      }
    }

    expand() {
      const resetHeight = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (!this.isOpen) return;

        requestAnimationFrame(() => {
          this.content.style.transition = "0";
          this.content.style.height = "auto";

          requestAnimationFrame(() => {
            this.content.style.height = null;
            this.content.style.transition = null;

            this.setExpandedAria();
            this.classList.add(this.expandedClass);
            this.trySetTabIndex(this.content, 0);

            this.fire("tabOpened");
            window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this);
          });
        });
      };

      const bindEvent = resetHeight.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = true;
      this.classList.remove(this.collapsedClass);
      this.content.style.height = this.content.scrollHeight + "px";
    }

    collapse() {
      const endTransition = (ev) => {
        if (ev.target !== this.content) return;
        this.content.removeEventListener(this.transitionendevent, bindEvent);

        if (this.isOpen) return;

        this.fire("elementClosed");
        window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this);
        this.setCollapsedAria();
        this.classList.add(this.collapsedClass);
        this.trySetTabIndex(this.content, -1);
      };

      const bindEvent = endTransition.bind(this);
      this.content.addEventListener(this.transitionendevent, bindEvent);

      this.isOpen = false;
      this.classList.remove(this.expandedClass);

      requestAnimationFrame(() => {
        this.content.style.transition = "0";
        this.content.style.height = this.content.scrollHeight + "px";

        requestAnimationFrame(() => {
          this.content.style.transition = null;
          this.content.style.height = this.collapsedHeight;
        });
      });
    }

    open() {
      this.selected = true;
      this.fire("elementSelected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this);
      this.expand();
      this.setAttribute("open", true);
    }

    close() {
      this.selected = false;
      this.fire("elementUnselected");
      window.MinimogEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this);
      this.collapse();
      this.removeAttribute("open");
    }

    toggle(event) {
      if (event) {
        event.preventDefault();
      }
      if (this.selected) {
        this.close();
      } else {
        this.open();

        if (this.oneAtATime) {
          const allItems = this.parentEl.querySelectorAll("collapsible-tab");
          const parent = this.closest("[data-first-level]");
          if (allItems.length) {
            allItems.forEach((item) => {
              if (item !== this && item.selected && parent !== item) {
                item.close();
              }
            });
          }
        }
      }
    }

    trySetTabIndex(el, index) {
      const tappableElements = el.querySelectorAll(this.defaultElements);
      if (tappableElements) {
        tappableElements.forEach((e) => {
          e.setAttribute("tabindex", index);
        });
      }
    }

    setExpandedAria() {
      this.trigger.setAttribute("aria-expanded", "true");
      this.content.setAttribute("aria-hidden", "false");
    }

    setCollapsedAria(el) {
      this.trigger.setAttribute("aria-expanded", "false");
      this.content.setAttribute("aria-hidden", "true");
    }

    attachEvents() {
      this.trigger.addEventListener("click", (event) => this.toggle(event));
    }

    setDefaultData() {
      this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      };
      this.transitionendevent = this.transitionendEventName();
      this.expandedClass = "is-expanded";
      this.collapsedClass = "is-collapsed";
      this.trigger = this.querySelector("[data-trigger]");
      this.content = this.querySelector("[data-content]");
      this.collapsedHeight = "0px";
      this.defaultElements = ["a", "button", "input:not(.focus-none)", "[data-trigger]"];
      this.oneAtATime = true;
      if (this.dataset.oneOpen) {
        this.oneAtATime = this.dataset.oneOpen === "true";
      }
    }

    fire(eventName) {
      let callbacks = this.events[eventName];
      if (callbacks) {
        for (let i = 0; i < callbacks.length; i++) {
          callbacks[i](this);
        }
      }
    }

    on(eventName, cb) {
      if (!this.events[eventName]) return;
      this.events[eventName].push(cb);
    }

    destroy() {
      this.trigger.removeEventListener("click", (event) => this.toggle(event));
      this.content.removeAttribute("aria-hidden");
      this.content.style.height = "auto";
      this.classList.remove(this.expandedClass, this.collapsedClass);
      this.removeAttribute("open");
    }
  }

  customElements.define("collapsible-tab", CollapsibleTab);
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".m-product-form-message",
          customFields: ["[data-product-custom-field]"],
          dynamicCheckout: ".m-product-dynamic-checkout",
        };
      }
      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.form = this.domNodes.form;
        this.productInfo = this.closest(".m-main-product--info");
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.cart = document.querySelector("m-cart-drawer");
        this.cartPage = document.querySelector("m-cart");
        this.customFields = document.querySelectorAll(this.selectors.customFields);
        if (this.domNodes.dynamicCheckout) this.enable_dynamic_checkout = true;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        if (this.domNodes.dynamicCheckout && this.customFields) {
          this.domNodes.dynamicCheckout.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.form.closest(".m-main-product--info"));
              if (missing && missing.length > 0) {
                e.stopPropagation();
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper,
                  method: "appendChild",
                  type: "warning",
                  message: window.MinimogStrings.requiredField,
                  delay: 100,
                });
                console.warn("Missing field(s): ", missing);
              }
            },
            true
          );
        }
      }
      toggleSpinner(show) {
        const method = show ? "add" : "remove";
        this.classList[method]("m-spinner-loading");
      }
      getFormData() {
        const formData = new FormData(this.form);
        if (this.closest('sticky-atc')) {
          const form = document.querySelector('.m-main-product--info .m-product-form--main form');
          const extraFormData = new FormData(form);

          for (const [key, value] of extraFormData.entries()) {
            if (!formData.has(key)) {
              formData.set(key, value);
            }
          }
        }

        return formData;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.toggleSpinner(true);
        const missing = validateForm(this.form.closest(".m-main-product--info"));

        if (missing && missing.length > 0) {
          console.warn("Missing field(s): ", missing);
          this.toggleSpinner(false);
          return window.MinimogTheme.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.MinimogStrings.requiredField,
          });
        }

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = this.getFormData();
        formData.append("sections", sectionsToBundle);
        formData.append("sections_url", window.location.pathname);

        config.body = formData;

        const { MinimogSettings, MinimogStrings } = window;
        fetch(`${MinimogSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // Handle Error
            if (response.status) {
              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.error || response.description,
                message: response.message,
              });
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.error || response.description,
                  },
                })
              );
              this.error = true;
              const variantId = formData.get("id");
              if (variantId === "" || variantId === null) {
                this.handleErrorMessageVariantPicker();
                return window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: MinimogStrings.selectVariant,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              } else {
                return window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "error",
                  message: response.message,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }
            }

            if (MinimogSettings.use_ajax_atc) {
              // Handle Ajax ATC
              if (this.cart && MinimogSettings.enable_cart_drawer) {
                MinimogTheme.Notification.show({
                  target: this.cart.querySelector("m-cart-items"),
                  method: "prepend",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  delay: 400,
                });
                // Open cart drawer
                this.cart.open();
              } else {
                window.MinimogTheme.Notification.show({
                  target: this.domNodes.errorWrapper ? this.domNodes.errorWrapper : document.body,
                  method: "appendChild",
                  type: "success",
                  message: MinimogStrings.itemAdded,
                  last: 3000,
                  sticky: !this.domNodes.errorWrapper,
                });
              }

              window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response, productVariantId: formData.get('id') });

              // dispatch product added event
              document.dispatchEvent(
                new CustomEvent("product-ajax:added", {
                  detail: {
                    product: response,
                  },
                })
              );

              this.error = false;

            } else {
              window.location = MinimogSettings.routes.cart;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.toggleSpinner(false);
          });
      }
      handleErrorMessageVariantPicker() {
        const variantPicker = this.productInfo && this.productInfo.querySelector("variant-picker");
        const options = variantPicker && variantPicker.querySelectorAll("[data-selected-value]");

        options &&
          options.forEach((option) => {
            const value = option.dataset.selectedValue;
            if (value === "") {
              option.classList.add("m-product-option--unselect");
              setTimeout(() => {
                option.classList.remove("m-product-option--unselect");
              }, 3000);
            }
          });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get("m-video-component")) {
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
      this.background = this.dataset.initMode !== "template";
      if (this.background) {
        MinimogTheme.initWhenVisible({
          element: this,
          callback: this.init.bind(this),
          threshold: 0,
        });
      } else {
        this.init();
      }
    }

    init() {
      this.parentSelector = this.dataset.parent || ".m-hero__bg";
      this.parent = this.closest(this.parentSelector);

      switch (this.dataset.type) {
        case "youtube":
          this.initYoutubeVideo();
          break;

        case "vimeo":
          this.initVimeoVideo();
          break;

        case "mp4":
          this.initMp4Video();
          break;
      }
    }

    initYoutubeVideo() {
      this.setAsLoading();
      this.loadScript("youtube").then(this.setupYoutubePlayer.bind(this));
    }

    initVimeoVideo() {
      this.setAsLoading();
      this.loadScript("vimeo").then(this.setupVimeoPlayer.bind(this));
    }

    initMp4Video() {
      const player = this.querySelector("video");

      if (player) {
        const promise = player.play();

        // Edge does not return a promise (video still plays)
        if (typeof promise !== "undefined") {
          promise
            .then(function () {
              // playback normal
            })
            .catch(function () {
              player.setAttribute("controls", "");
            });
        }
      }
    }

    loadScript(videoType) {
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        document.body.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
        script.async = true;
        script.src = videoType === "youtube" ? "//www.youtube.com/iframe_api" : "//player.vimeo.com/api/player.js";
      });
    }

    setAsLoading() {
      this.parent.setAttribute("loading", true);
    }

    setAsLoaded() {
      this.parent.removeAttribute("loading");
      this.parent.setAttribute("loaded", true);
    }

    setupYoutubePlayer() {
      const videoId = this.dataset.videoId;
      const playerInterval = setInterval(() => {
        if (window.YT) {
          window.YT.ready(() => {
            const element = document.createElement("div");
            this.appendChild(element);

            this.player = new YT.Player(element, {
              videoId: videoId,
              playerVars: {
                showinfo: 0,
                controls: false,
                fs: 0,
                rel: 0,
                height: "100%",
                width: "100%",
                iv_load_policy: 3,
                html5: 1,
                loop: 1,
                playsinline: 1,
                modestbranding: 1,
                disablekb: 1,
              },
              events: {
                onReady: this.onYoutubeReady.bind(this),
                onStateChange: this.onYoutubeStateChange.bind(this),
              },
            });
            clearInterval(playerInterval);
          });
        }
      }, 50);
    }

    onYoutubeReady() {
      this.iframe = this.querySelector("iframe"); // iframe once YT loads
      this.iframe.setAttribute("tabindex", "-1");
      if (typeof this.player.mute === "function") this.player.mute();
      if (typeof this.player.playVideo === "function") this.player.playVideo();

      this.setAsLoaded();

      // pause when out of view
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.youtubePlay();
              } else {
                this.youtubePause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      }
    }

    onYoutubeStateChange(event) {
      switch (event.data) {
        case -1: // unstarted
          // Handle low power state on iOS by checking if
          // video is reset to unplayed after attempting to buffer
          if (this.attemptedToPlay) {
            this.setAsLoaded();
            // this.closest('.banner').classList.add('video-interactable');
          }
          break;
        case 0: // ended, loop it
          this.youtubePlay();
          break;
        case 1: // playing
          this.setAsLoaded();
          break;
        case 3: // buffering
          this.attemptedToPlay = true;
          break;
      }
    }

    youtubePlay() {
      if (this.player && typeof this.player.playVideo === "function") {
        this.player.playVideo();
      }
    }

    youtubePause() {
      if (this.player && typeof this.player.pauseVideo === "function") {
        this.player.pauseVideo();
      }
    }

    setupVimeoPlayer() {
      const videoId = this.dataset.videoId;

      const playerInterval = setInterval(() => {
        if (window.Vimeo) {
          this.player = new Vimeo.Player(this, {
            id: videoId,
            autoplay: true,
            autopause: false,
            background: false,
            controls: false,
            loop: true,
            height: "100%",
            width: "100%",
          });
          this.player.ready().then(this.onVimeoReady.bind(this));
          clearInterval(playerInterval);
        }
      }, 50);
    }

    onVimeoReady() {
      this.iframe = this.querySelector("iframe");
      this.iframe.setAttribute("tabindex", "-1");

      this.player.setMuted(true);

      this.setAsLoaded();

      // pause when out of view
      const observer = new IntersectionObserver(
        (entries, _observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.vimeoPlay();
            } else {
              this.vimeoPause();
            }
          });
        },
        { rootMargin: "0px 0px 50px 0px" }
      );

      observer.observe(this.iframe);
    }

    vimeoPlay() {
      if (this.player && typeof this.player.play === "function") {
        this.player.play();
      }
    }

    vimeoPause() {
      if (this.player && typeof this.player.pause === "function") {
        this.player.pause();
      }
    }
  }
  customElements.define("m-video-component", VideoComponent);
}

if (!customElements.get("m-search-popup")) {
  class MSearchPopup extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        container: "[data-search-container]",
        form: "form",
        input: "[data-search-input]",
        submit: 'button[type="submit"]',
        loading: "[data-spinner]",
        close: "[data-close-search]",
      };

      const searchPopup = document.querySelector("[data-search-popup]");
      if (!searchPopup) return;

      this.domNodes = queryDomNodes(this.selectors, searchPopup);
      this.domNodes.searchPopup = searchPopup;
      document.body.appendChild(searchPopup);
      addEventDelegate({
        selector: "[data-open-search-popup]",
        handler: () => this.openSearchPopup(),
      });

      const { input, submit, close, form } = this.domNodes;
      if (input) {
        input.addEventListener("keydown", (e) => {
          // ESC
          if (e.keyCode === 27) {
            this.closeSearchPopup();
          }
        });
      }
      submit.addEventListener("click", (e) => {
        e.preventDefault();
        if (input.value) {
          form.submit();
        }
      });
      close.addEventListener("click", (e) => {
        this.closeSearchPopup();
        MinimogEvents.emit(MinimogTheme.pubSubEvents.closeSearchPopup);
      });
      searchPopup.addEventListener("click", (e) => {
        if (e.target === searchPopup) {
          this.closeSearchPopup();
        }
      });

      MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
        if (this.hasAttribute("open")) this.closeSearchPopup();
      });
    }

    openSearchPopup() {
      const { searchPopup, input, container } = this.domNodes;
      searchPopup.style.removeProperty("visibility");
      searchPopup.style.setProperty("opacity", "1");
      container.classList.add("m-show-search");
      this.setAttribute("open", true);
      setTimeout(() => {
        container.style.removeProperty("--m-durations");
        input.focus();
      }, 350);
      document.documentElement.classList.add("prevent-scroll");
      MinimogEvents.emit(MinimogTheme.pubSubEvents.openSearchPopup, this);
    }

    closeSearchPopup() {
      const { searchPopup, container } = this.domNodes;
      container.classList.remove("m-show-search");
      searchPopup.style.setProperty("opacity", "0");
      setTimeout(() => {
        searchPopup.style.setProperty("visibility", "hidden");
        container.style.setProperty("--m-durations", ".3s");
        document.documentElement.classList.remove("prevent-scroll");
        this.removeAttribute("open");
      }, 350);
    }
  }

  customElements.define("m-search-popup", MSearchPopup);
}

if (!customElements.get("m-select-component")) {
  class MSelectComponent extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        elSelectNative: ".js-selectNative",
        elSelectCustom: ".js-selectCustom",
        elSelectCustomBox: ".m-select-custom--trigger",
        elSelectCustomOpts: ".m-select-custom--options",
        elSelectCustomTriggerText: ".m-select-custom--trigger-text",
        customOptionList: [".m-select-custom--option"],
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.optionChecked = "";

      window.addEventListener("DOMContentLoaded", () => {
        this.classList.remove("m:hidden");
      });
      this.setDefaultValue();
      this.initSelect();
    }

    setDefaultValue() {
      const { elSelectNative } = this.domNodes;
      const value = elSelectNative.options[elSelectNative.selectedIndex].value;
      const text = elSelectNative.options[elSelectNative.selectedIndex].text;
      this.updateCustomSelectChecked(value, text);
    }

    initSelect() {
      this.classList.remove("m:hidden");
      const { elSelectNative, elSelectCustom, elSelectCustomBox } = this.domNodes;

      elSelectCustomBox.addEventListener("click", () => {
        const isClose = !elSelectCustom.classList.contains("isActive");
        if (isClose) {
          this.openSelect();
        } else {
          this.closeSelect();
        }
      });

      this.domNodes.customOptionList.forEach((option) => {
        option.addEventListener("click", (e) => {
          const value = e.target.getAttribute("data-value");
          elSelectNative.value = value;
          this.closeSelect();
          this.updateCustomSelectChecked(value, e.target.textContent);
          elSelectNative.dispatchEvent(new Event("change"));
          elSelectNative.dispatchEvent(new Event("click"));
        });
      });
    }

    openSelect() {
      const allCustomSelect = document.querySelectorAll("m-select-component");
      document.addEventListener("click", (e) => this.handleClickOutside(e));
      if (allCustomSelect.length > 0) {
        allCustomSelect.forEach((select) => {
          select.closeSelect();
        });
      }
      this.domNodes.elSelectCustom.classList.add("isActive");
    }

    closeSelect() {
      this.domNodes.elSelectCustom.classList.remove("isActive");
    }

    updateCustomSelectChecked(value, text) {
      const { elSelectCustomOpts, elSelectCustomTriggerText } = this.domNodes;
      const prevValue = this.optionChecked;
      const elPrevOption = elSelectCustomOpts.querySelector(`[data-value="${prevValue}"`);

      const elOption = elSelectCustomOpts.querySelector(`[data-value="${value}"`);

      if (elPrevOption) {
        elPrevOption.classList.remove("isActive");
      }

      if (elOption) {
        elOption.classList.add("isActive");
      }

      elSelectCustomTriggerText.textContent = text;
      this.optionChecked = value;
    }

    handleClickOutside(e) {
      const { elSelectCustom } = this.domNodes;
      const didClickedOutside = !elSelectCustom.contains(e.target);
      if (didClickedOutside) {
        this.closeSelect();
      }
    }
  }

  customElements.define("m-select-component", MSelectComponent);
}

class MQuantityInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get input() {
    return this.querySelector("input");
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.input.addEventListener('focus', () => setTimeout(() => this.input.select()));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = MinimogEvents.subscribe(
      MinimogTheme.pubSubEvents.quantityUpdate,
      this.validateQtyRules.bind(this)
    );

    // Sync 2 inputs inside product info and sticky ATC
    this.shouldSync = this.closest('.m-main-product--info') || this.closest('sticky-atc');
    if (this.shouldSync) {
      window.addEventListener("syncProductQuantity", (event) => {
        if (event.detail !== this.input.value) {
          this.input.value = event.detail;
          this.validateQtyRules();
        }
      });
    }
  }
  onInputChange() {
    if (this.shouldSync) {
      window.dispatchEvent(new CustomEvent("syncProductQuantity", { detail: this.input.value }));
    }

    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.currentTarget.name === 'plus') {
      if (parseInt(this.input.getAttribute('data-min')) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.getAttribute('data-min');
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.getAttribute('data-min') === previousValue && event.currentTarget.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    const buttonMinus = this.querySelector(".m-quantity__button[name='minus']");
    const buttonPlus = this.querySelector(".m-quantity__button[name='plus']");

    if (this.input.min) {
      const min = parseInt(this.input.min);
      buttonMinus.classList.toggle("m:disabled", value <= min);
    } else {
      buttonMinus.classList.remove("m:disabled");
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      buttonPlus.classList.toggle("m:disabled", value >= max);
    } else {
      buttonPlus.classList.remove("m:disabled");
    }
  }

  updateQuantityRules(sectionId, productId, parsedHTML) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;
    const selectors = [
      ".m-quantity__input",
      ".quantity__rules",
      ".m-product-option--label",
    ];
    const quantityFormUpdated = parsedHTML.getElementById(
      `QuantityForm-${sectionId}`
    );
    const quantityForm = this.closest(`#QuantityForm-${sectionId}`);
    for (let selector of selectors) {
      const current = quantityForm.querySelector(selector);
      const updated = quantityFormUpdated.querySelector(selector);
      if (!current || !updated) continue;

      if (selector === ".m-quantity__input") {
        const attributes = [
          "data-cart-quantity",
          "data-min",
          "data-max",
          "step",
        ];
        for (let attribute of attributes) {
          const valueUpdated = updated.getAttribute(attribute);
          if (valueUpdated !== null) {
            current.setAttribute(attribute, valueUpdated);
          } else {
            current.removeAttribute(attribute);
          }
        }
      } else {
        current.innerHTML = updated.innerHTML;
      }
    }
  }

  setQuantityBoundries(sectionId, productId) {
    if (sectionId !== this.sectionId || productId !== this.productId) return;

    const data = {
      cartQuantity: this.input.hasAttribute("data-cart-quantity")
        ? parseInt(this.input.getAttribute("data-cart-quantity"))
        : 0,
      min: this.input.hasAttribute("data-min") && this.input.getAttribute("data-min")
        ? parseInt(this.input.getAttribute("data-min"))
        : 1,
      max: this.input.hasAttribute("data-max") && this.input.getAttribute("data-max")
        ? parseInt(this.input.getAttribute("data-max"))
        : null,
      step: this.input.hasAttribute("step") && this.input.getAttribute("step")
        ? parseInt(this.input.getAttribute("step"))
        : 1,
    };

    let min = data.min;
    const max = data.max === null ? data.max : data.max - data.cartQuantity;
    if (max !== null) min = Math.min(min, max);
    if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

    this.input.min = min;

    if (max) {
      this.input.max = max;
    } else {
      this.input.removeAttribute("max");
    }
    this.input.value = min;

    MinimogEvents.emit(MinimogTheme.pubSubEvents.quantityUpdate, undefined);
  }

  reset() {
    this.input.value = this.input.defaultValue;
  }

  setValidity(message) {
    this.input.setCustomValidity(message);
    this.input.reportValidity();
    this.input.value = this.input.defaultValue;
    this.input.select();
    // Avoid the button being disabled when enter a value is greater than max value or less than min value
    this.validateQtyRules();
  }
}

customElements.define("m-quantity-input", MQuantityInput);

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // Save product Id
    if (isStorageSupported("local")) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = "minimog-recently-viewed";
      const items = JSON.parse(window.localStorage.getItem(cookieName) || "[]");

      // Check current product already exists, if not push to array
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // Save to localStorage
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
    }
  }
}
customElements.define("product-recently-viewed", ProductRecentlyViewed);

class ProgressBar extends HTMLElement {
  constructor() {
    super();

    if (this.hasAttribute('style')) return;

    if (this.dataset.from) {
      this.initProgress();
    }

    MinimogTheme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 0,
    });
  }

  init() {
    this.setPercentage(this.dataset.value, this.dataset.max);
  }

  initProgress() {
    this.setPercentage(this.dataset.from, this.dataset.max);
  }

  setPercentage(val1, val2) {
    this.style.setProperty('--percent', `${(parseInt(val1) / parseInt(val2)) * 100}%`);
  }
}
customElements.define('progress-bar', ProgressBar);

if (!customElements.get("m-cart-count")) {
  class MCartCount extends HTMLElement {
    constructor() {
      super();
      this.getSectionToRenderListener = this.getSectionToRender.bind(this);
    }

    cartUpdateUnsubscriber = undefined;

    get sectionName() {
      return 'cart-count';
    }

    getSectionToRender(event) {
      event.detail.sections.push(this.sectionName);
    }

    connectedCallback() {
      document.addEventListener('cart:grouped-sections', this.getSectionToRenderListener);

      this.cartUpdateUnsubscriber = MinimogEvents.subscribe(
        MinimogTheme.pubSubEvents.cartUpdate,
        this.onCartUpdate.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    get itemCount() {
      return parseInt(this.innerText);
    }

    onCartUpdate(event) {
      if (event.cart.errors) return;
      const sectionToRender = new DOMParser().parseFromString(event.cart.sections[this.sectionName], 'text/html');
      this.onUpdate(sectionToRender);
    }

    onUpdate(section) {
      this.innerText = section.querySelector('.m-cart-count').innerText;
      const method = this.itemCount === 0 ? 'add' : 'remove';
      this.classList[method]('m:hidden');
    }
  }
  customElements.define('m-cart-count', MCartCount);
}
